 
<template>
  <div class="IM-box">
    <videoRoom v-if="showVideoRoom && bizUnionId" @outRoom='outVideoRoom' :roomCode='synergyRoomCode'
      :bizUnionId='bizUnionId' />
    <div v-if="showIm" class="IM">
      <!-- 切换 -->
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="当前会话" name="first"></el-tab-pane>
          <template v-if="routerName != 'consultRoom'">
            <el-tab-pane label="专项会话" name="second"
              :disabled="!($store.state.serviceItem && $store.state.serviceItem.wholeCourseId)">
            </el-tab-pane>
            <el-tab-pane label="医护对话" name="third"
              :disabled="!$store.state.serviceItem.wholeCourseId || $store.state.serviceItem.teamType != 'other'">
            </el-tab-pane>
            <el-tab-pane label="协同会话" name="four"></el-tab-pane>
          </template>
        </el-tabs>
      </div>
      <div :class="activeName == 'four' && isCooperateIM ?'four-content':'scroll-content'"
        :style="`height: calc(100% - ${topHeight}px)`">
        <div class='four-back' v-if="activeName=='four'&& !isCooperateIM" @click='fourBack'><i
            class="el-icon-arrow-left"></i> 返回上一级</div>
        <!-- <videoRoom v-if="showVideoRoom" @outRoom='outVideoRoom' /> -->
        <!-- 协同会话 -->
        <!-- 专项会话问诊列表 -->
        <div v-if="isMiniRoom || isCooperateIM" style="height:100%">
          <createMiniRoom v-if="isMiniRoom" style="height:100%" :IMInfo="IMInfo" :wholeCourseId="wholeCourseId"
            :statusIMInfo="IMInfo.status" @childByValue="childByValue">
          </createMiniRoom>
          <cooperateIM ref='cooperateIM' v-else style="height:100%" :IMInfo="IMInfo" :wholeCourseId="wholeCourseId"
            @childToRoom="childToRoom">
          </cooperateIM>
        </div>
        <template v-else>
          <vue-scroll :ops="ops" @handle-scroll="handleScroll" @handle-scroll-complete="handleComplete"
            @handle-resize="handleResize" ref="vs">
            <div class="slot-load" v-if="noData">
              <i class="el-icon-loading" />
              稍等，消息加载中…
            </div>
            <div class="content" v-for="(item, index) in recordContent" :key="index" :id="item.id"
              v-show="item.payload.extension != 1006 && item.payload.extension != 2006">
              <span class="content-text"
                v-if="item.payload && item.payload.extension != 10">{{
                item.createTime ? item.createTime : newDate
              }}</span>
              <!-- 自己发的 -->
              <div class="message-out-box" v-if="item.flow == 'out'">
                <!-- 撤销菜单  item.isPlaceMsg为1时消息已撤回 -->
                <div class="out-box"
                  v-if="item.payload && item.payload.extension != 10 && item.isPlaceMsg !== 1">
                  <div class="messageBox" style="max-width: 80%">
                    <div class="userName" v-if="routerName != 'consultRoom'">疗程管理师</div>
                    <div class="userName" v-else>客服佳佳</div>
                    <div class="messageCon">
                      <template v-if="item.type == 'TIMTextElem'">
                        <textMsgComponent :data="item.payload" bgColor="#1A7BFC" color="#fff" :rightMenuData="{
                            createTime: item.createTime
                          }" :showRightMenu="checkMenuIsShowByCreateTime">
                          <template slot="rightMenu" slot-scope="scope">
                            <li @click="handleWithdraw(scope, item)">撤回</li>
                          </template>
                        </textMsgComponent>
                      </template>
                      <!-- 自定义消息 -->
                      <template v-if="item.type == 'TIMCustomElem'">
                        <patientTaskReminder v-if="item.payload.extension == 2008"
                          :data="JSON.parse(item.payload.data)"></patientTaskReminder>
                        <custom-zeros v-if="item.payload.extension === '0'" :data="JSON.parse(item.payload.data)" />
                        <custom-one bgColor="#1A7BFC" color="#fff" v-if="item.payload.extension == 1||item.payload.extension == 2007 || item.payload.extension == 2018"
                          :data="item.payload" />
                        <custom-two v-if="item.payload.extension == 2" :data="JSON.parse(item.payload.data)" />
                        <custom-four v-if="item.payload.extension == 4" :data="item.payload.data" />
                        <custom-six
                          v-if="item.payload.extension == 6 || (item.payload.extension == 19 && JSON.parse(item.payload.data).patientSleepScoreId)"
                          :payloadData="item.payload" :wholeCourseId="wholeCourseId" :IMInfo="IMInfo"
                          @changeShowIm="changeShowIm" />
                        <custom-further v-if="item.payload.extension == 2003" :payloadData="item.payload"
                          :wholeCourseId="wholeCourseId" :IMInfo="IMInfo" />
                        <custom-target v-if="item.payload.extension == 36" :data="item.payload" />
                        <custom-symptom v-if="item.payload.extension == 34" :data="item.payload" />
                        <custom-seven v-if="item.payload.extension == 7" :data="JSON.parse(item.payload.data)" />
                        <custom-eight v-if="item.payload.extension == 8" :data="JSON.parse(item.payload.data)" />
                        <custom-nine v-if="item.payload.extension == 9" :data="JSON.parse(item.payload.data)" />
                        <custom-twelve v-if="item.payload.extension == 12"
                          :data="item.payload.data ? JSON.parse(item.payload.data) : {}" />
                        <custom-thirteen v-if="item.payload.extension == 13" :data="JSON.parse(item.payload.data)" />
                        <custom-fourteen v-if="item.payload.extension == 14" :data="item.payload"
                          @openDoctorImage="openDoctorImage" />
                        <custom-sixteen v-if="item.payload.extension == 16" :data="JSON.parse(item.payload.data)" />
                        <custom-seventeen v-if="item.payload.extension == 17" :data="item.payload" />
                        <custom-eighteen v-if="item.payload.extension == 18" :data="JSON.parse(item.payload.data)" />

                        <custom-twenty v-if="item.payload.extension == 20" :data="JSON.parse(item.payload.data)"
                          :fileName="item.payload.description" />
                        <!-- 团队卡片 -->
                        <custom-thirtyseven v-if="item.payload.extension == 37" :data="JSON.parse(item.payload.data)" />
                        <!-- 推送服务&续约当前 -->
                        <custom-twentysix v-if="item.payload.extension == 23 || item.payload.extension == 28"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 问诊订单 -->
                        <custom-twentyseven v-if="item.payload.extension == 24" :data="JSON.parse(item.payload.data)" />
                        <!-- 填写主诉26 -->
                        <custom-twentynine v-if="item.payload.extension == 26" :data="JSON.parse(item.payload.data)" />
                        <!-- 康复评估报告 29 -->
                        <custom-thirtytwo v-if="item.payload.extension == 29" :data="JSON.parse(item.payload.data)" />
                        <!-- 发送病历夹 30 -->
                        <custom-thirtyone v-if="item.payload.extension == 30" :data="JSON.parse(item.payload.data)" />
                        <custom-symptomfeedback v-if="item.payload.extension == 38"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 患者指标异常卡片 mmm -->
                        <custom-norm v-if="item.payload.extension == 2005" :data="JSON.parse(item.payload.data)" />
                        <!-- 义诊卡片32-->
                        <custom-thirtyfive v-if="item.payload.extension == 32" :data="JSON.parse(item.payload.data)" />
                        <!-- 问卷推送-2.0.2最新 31 -->
                        <custom-thirtyfour v-if="item.payload.extension == 31" :data="JSON.parse(item.payload.data)"
                          @inModal="inModal" @showDetailsList='showDetailsList' />
                        <div style="width: 300px;" v-if="item.payload.extension == 2001">
                          <show-video :videoSrc="item.payload.data ? imgBaseURL + item.payload.data : ''">
                          </show-video>
                        </div>
                        <!-- <custom-twentythree
                          v-if="item.payload.extension == 1003"
                          :data="JSON.parse(item.payload.data)"
                        /> -->

                        <custom-twentyfour v-if="item.payload.extension == 1002"
                          :data="JSON.parse(item.payload.data)" />
                        <custom-twentyfive v-if="item.payload.extension == 1005"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 康复反馈-2002 -->
                        <custom-thirtythree v-if="item.payload.extension == 2002" :data="JSON.parse(item.payload.data)">
                        </custom-thirtythree>
                        <textMsgComponent v-if="item.payload.extension == 1007 || item.payload.extension == 1008"
                          :data="{ text: item.payload.data }"></textMsgComponent>
                        <textMsgComponent v-if="item.payload.extension == 2000" :data="JSON.parse(item.payload.data)"
                          bgColor="#1A7BFC" color="#fff" :rightMenuData="{
                            createTime: item.createTime
                          }" :showRightMenu="checkMenuIsShowByCreateTime">
                          <template slot="rightMenu" slot-scope="scope">
                            <li @click="handleWithdraw(scope, item)">撤回</li>
                          </template>
                        </textMsgComponent>
                        <!-- 系统消息部分推送的卡片-通话进行中提示 -->
                        <custom-sythree v-if="item.payload.extension == 2009" :curOnlineNum='curOnlineNum'
                          :data="JSON.parse(item.payload.data)" @joinVideo='joinVideo' />
                        <!-- 系统消息部分推送的卡片-病历卡片 2011处方卡片 -->
                        <custom-syeight v-if="item.payload.extension == 2010 || item.payload.extension == 2011"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 系统消息部分推送的卡片-点击查看患者详情 -->
                        <custom-sytwo v-if="item.payload.extension == 2012" :data="JSON.parse(item.payload.data)" />
                        <!-- 系统消息部分推送的卡片-点击发起视频通话 -->
                        <!-- <custom-syone v-if="item.payload.extension == 6"
                          :data="JSON.parse(item.payload.data)" /> -->
                        <!-- 系统消息部分推送的卡片-视频问诊结束 -->
                        <!-- <custom-syfour v-if="item.payload.extension == 6" :data="JSON.parse(item.payload.data)" /> -->
                        <!-- 会诊-服务卡片 -->
                        <custom-syfive v-if="item.payload.extension == 2013 || item.payload.extension == 2015"
                          :data="JSON.parse(item.payload.data)" :extension="item.payload.extension" />
                        <!-- 会诊-房间已经开启-立即加入 -->
                        <custom-sysix v-if="item.payload.extension == 2014" :data="JSON.parse(item.payload.data)"
                          @childToRoom='childToRoom' />
                        <!-- 会诊-小结 -->
                        <custom-synine v-if="item.payload.extension == 2016" :data="JSON.parse(item.payload.data)" />
                        <!-- 医生退诊 -->
                        <custom-syten v-if="item.payload.extension == 2017" :data="item.payload.data" />
                        <custom-template v-if="item.payload.extension == 2019" :data="JSON.parse(item.payload.data)"/>

                      </template>
                      <!-- 文件消息 -->
                      <template v-if="item.type == 'TIMFileElem'">
                        <fileMsg :data="item.payload" />
                      </template>
                      <!-- 语音消息 -->
                      <template v-if="item.type == 'TIMSoundElem'">
                        <audioMsg :data="item.payload" />
                      </template>
                      <!-- 图片消息 -->
                      <template v-if="item.type == 'TIMImageElem'">
                        <imageMsg :data="item.payload" :msgId="item.id" :imgName="item.customName"
                          @enlargePicture="enlargePicture" />
                      </template>
                      <div style="width: 300px;" v-if="item.type == 'TIMVideoFileElem'">
                        <show-video :videoSrc="item.payload.data ? imgBaseURL + item.payload.data : ''">
                        </show-video>
                      </div>
                    </div>
                    <div class="ready" v-if="showReadStatus">
                      <div :class="sequence >= item.sequence ? 'ready-radio' : 'ready-radio-blue' "></div>
                      <div :class="sequence >= item.sequence ? 'ready-radio-text' : 'ready-radio-blue-text' ">
                        {{ sequence >= item.sequence  ? '已读' : '未读' }}</div>
                    </div>
                  </div>
                  <el-image :src="imgHead" class="head"></el-image>
                </div>
                <div v-if="item.isPlaceMsg === 1" class="recall-box">
                  <span class="recall">您已撤回一条消息</span>
                </div>
              </div>
              <!-- 其他人发的 -->
              <div class="message-in-box" v-else>
                <div class="in-box"
                  v-if="item.payload && item.payload.extension != 10 && item.payload.extension != 1006 && item.isPlaceMsg !== 1">
                  <el-image v-if="item.nick" :src="item.avatar ? item.avatar : imgHead" class="head"></el-image>
                  <el-image v-else :src="imgHead" class="head"></el-image>
                  <div class="messageBox" style="max-width: 80%">
                    <div class="userName">
                      {{ item.payload.extension=='2013'?JSON.parse(item.payload.data).fromDoctorName:item.nick }}</div>
                    <div class="messageCon">
                      <!-- 文字消息 -->
                      <template v-if="item.type == 'TIMTextElem'">
                        <textMsgComponent :data="
                            item.payload
                              ? item.payload
                              : JSON.parse(item.payload.data)
                          "></textMsgComponent>
                      </template>
                      <!-- 自定义消息 -->
                      <template v-if="item.type == 'TIMCustomElem'">
                        <patientTaskReminder v-if="item.payload.extension == 2008"
                          :data="JSON.parse(item.payload.data)"></patientTaskReminder>
                        <custom-zeros v-if="item.payload.extension === '0'" :data="JSON.parse(item.payload.data)" />
                        <custom-one v-if="item.payload.extension == 1 || item.payload.extension == 2018|| item.payload.extension == 2007"
                          :data="item.payload" />
                        <custom-two v-if="item.payload.extension == 2" :data="JSON.parse(item.payload.data)" />
                        <custom-three v-if="item.payload.extension == 3" :data="JSON.parse(item.payload.data)" />
                        <custom-four v-if="item.payload.extension == 4" :data="item.payload.data" />
                        <custom-five v-if="item.payload.extension == 5" :data="JSON.parse(item.payload.data)" />
                        <custom-six
                          v-if="item.payload.extension == 6 || (item.payload.extension == 19 && JSON.parse(item.payload.data).patientSleepScoreId)"
                          :payloadData="item.payload" :wholeCourseId="wholeCourseId" :IMInfo="IMInfo"
                          @changeShowIm="changeShowIm" />
                        <custom-further v-if="item.payload.extension == 2003" :payloadData="item.payload"
                          :wholeCourseId="wholeCourseId" :IMInfo="IMInfo" />
                        <custom-target v-if="item.payload.extension == 36" :data="item.payload" />
                        <custom-symptom v-if="item.payload.extension == 34" :data="item.payload" />
                        <custom-reports v-if="item.payload.extension == 33" :payloadData="item.payload" />
                        <custom-seven v-if="item.payload.extension == 7" :data="JSON.parse(item.payload.data)" />
                        <custom-eight v-if="item.payload.extension == 8" :data="JSON.parse(item.payload.data)" />
                        <custom-nine v-if="item.payload.extension == 9" :data="JSON.parse(item.payload.data)" />
                        <custom-twelve v-if="item.payload.extension == 12"
                          :data="item.payload.data ? JSON.parse(item.payload.data) : {}" />
                        <custom-thirteen v-if="item.payload.extension == 13" :data="JSON.parse(item.payload.data)" />
                        <custom-test v-if="item.payload.extension ==999" @enlargePicture="enlargePicture"
                          :data="JSON.parse(item.payload.data)" />
                        <custom-fourteen v-if="item.payload.extension == 14" :data="item.payload"
                          @openDoctorImage="openDoctorImage" />
                        <custom-sixteen v-if="item.payload.extension == 16" :data="JSON.parse(item.payload.data)" />
                        <custom-seventeen v-if="item.payload.extension == 17" :data="item.payload" />
                        <custom-eighteen v-if="item.payload.extension == 18" :data="JSON.parse(item.payload.data)" />
                        <!-- patientSleepScoreId没有该属性或者值为空，则不是睡眠问卷 -->
                        <custom-nighteen
                          v-if="item.payload.extension == 19 && !JSON.parse(item.payload.data).patientSleepScoreId"
                          :data="JSON.parse(item.payload.data)" :payloadData="item.payload"
                          :wholeCourseId="wholeCourseId" :IMInfo="IMInfo" />
                        <custom-files v-if="item.payload.extension == 2004" :data="JSON.parse(item.payload.data)"
                          :payloadData="item.payload" :wholeCourseId="wholeCourseId" :IMInfo="IMInfo" />
                        <custom-twenty v-if="item.payload.extension == 20" :data="JSON.parse(item.payload.data)"
                          :fileName="item.payload.description" />
                        <custom-twentytwo v-if="item.payload.extension == 22" :data="JSON.parse(item.payload.data)" />
                        <!-- 推送服务&续约当前 -->
                        <custom-twentysix v-if="item.payload.extension == 23 || item.payload.extension == 28"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 问诊订单 -->
                        <custom-twentyseven v-if="item.payload.extension == 24" :data="JSON.parse(item.payload.data)" />
                        <!-- 填写主诉26 -->
                        <custom-twentynine v-if="item.payload.extension == 26" :data="JSON.parse(item.payload.data)" />
                        <!-- 问诊订单已支付 25 -->
                        <custom-twentyeight v-if="item.payload.extension == 25" :data="JSON.parse(item.payload.data)" />
                        <!-- 问诊主诉填写完成 27 -->
                        <custom-thirty v-if="item.payload.extension == 27" :data="JSON.parse(item.payload.data)" />
                        <!-- 康复评估报告 29 -->
                        <custom-thirtytwo v-if="item.payload.extension == 29" :data="JSON.parse(item.payload.data)" />
                        <!-- 发送病历夹 30 -->
                        <custom-thirtyone v-if="item.payload.extension == 30" :data="JSON.parse(item.payload.data)" />
                        <!-- 义诊卡片32-->
                        <custom-thirtyfive v-if="item.payload.extension == 32" :data="JSON.parse(item.payload.data)" />
                        <!-- 异常症状反馈卡片 mmm-->
                        <custom-symptomfeedback v-if="item.payload.extension == 38"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 患者指标异常卡片 mmm -->
                        <custom-norm v-if="item.payload.extension == 2005" :data="JSON.parse(item.payload.data)" />
                        <!-- 问卷推送-2.0.2最新 -->
                        <custom-thirtyfour v-if="item.payload.extension == 31" :data="JSON.parse(item.payload.data)"
                          @inModal="inModal" @showDetailsList='showDetailsList' />
                        <custom-twentythree v-if="item.payload.extension == 1004"
                          :data="JSON.parse(item.payload.data)" />

                        <custom-twentyfour v-if="item.payload.extension == 1002"
                          :data="JSON.parse(item.payload.data)" />

                        <custom-twentyfive v-if="item.payload.extension == 1005"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 团队卡片 -->
                        <custom-thirtyseven v-if="item.payload.extension == 37" :data="JSON.parse(item.payload.data)" />
                        <!-- 康复反馈-2002 -->
                        <custom-thirtythree v-if="item.payload.extension == 2002" :data="JSON.parse(item.payload.data)">
                        </custom-thirtythree>
                        <textMsgComponent v-if="item.payload.extension == 1007 || item.payload.extension == 1008"
                          :data="{ text: item.payload.data }"></textMsgComponent>
                        <div style="width: 300px;" v-if="item.payload.extension == 2001">
                          <show-video :videoSrc="item.payload.data?imgBaseURL + item.payload.data:''">
                          </show-video>
                        </div>
                        <textMsgComponent v-if="item.payload.extension == 2000" :data="JSON.parse(item.payload.data)">
                        </textMsgComponent>
                        <!-- 系统消息部分推送的卡片-通话进行中提示 -->
                        <custom-sythree v-if="item.payload.extension == 2009" :curOnlineNum='curOnlineNum'
                          :data="JSON.parse(item.payload.data)" @joinVideo='joinVideo' />
                        <!-- 系统消息部分推送的卡片-病历卡片 2011处方卡片 -->
                        <custom-syeight v-if="item.payload.extension == 2010 || item.payload.extension == 2011"
                          :data="JSON.parse(item.payload.data)" />
                        <!-- 系统消息部分推送的卡片-点击查看患者详情 -->
                        <custom-sytwo v-if="item.payload.extension == 2012" :data="JSON.parse(item.payload.data)" />
                        <!-- 系统消息部分推送的卡片-点击发起视频通话 -->
                        <!-- <custom-syone v-if="item.payload.extension == 6"
                          :data="JSON.parse(item.payload.data)" /> -->
                        <!-- 系统消息部分推送的卡片-视频问诊结束 -->
                        <!-- <custom-syfour v-if="item.payload.extension == 6" :data="JSON.parse(item.payload.data)" /> -->
                        <!-- 会诊-服务卡片 -->
                        <custom-syfive v-if="item.payload.extension == 2013 || item.payload.extension == 2015"
                          :data="JSON.parse(item.payload.data)" :extension="item.payload.extension" />
                        <!-- 会诊-房间已经开启-立即加入 -->
                        <custom-sysix v-if="item.payload.extension == 2014" :data="JSON.parse(item.payload.data)"
                          @childToRoom='childToRoom' />
                        <!-- 会诊-小结 -->
                        <custom-synine v-if="item.payload.extension == 2016" :data="JSON.parse(item.payload.data)" />
                        <!-- 医生退诊 -->
                        <custom-syten v-if="item.payload.extension == 2017" :data="item.payload.data" />
                        <!-- 卡片模板 落地页 -->
                        <custom-template v-if="item.payload.extension == 2019" :data="JSON.parse(item.payload.data)"/>
                      </template>
                      <!-- 文件消息 -->
                      <template v-if="item.type == 'TIMFileElem'">
                        <fileMsg :data="item.payload" />
                      </template>
                      <!-- 语音消息 -->
                      <template v-if="item.type == 'TIMSoundElem'">
                        <audioMsg :data="item.payload" />
                      </template>
                      <!-- 图片消息 -->
                      <template v-if="item.type == 'TIMImageElem'">
                        <imageMsg :data="item.payload" :msgId="item.id" :imgName="item.customName"
                          @enlargePicture="enlargePicture" />
                      </template>
                      <div style="width: 300px;" v-if="item.type == 'TIMVideoFileElem'">
                        <show-video :videoSrc="imgBaseURL + item.payload.data">
                        </show-video>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.isPlaceMsg === 1" class="recall-box">
                  <span class="recall">{{ item.nick }}已撤回一条消息</span>
                </div>
              </div>
            </div>

            <!-- 已撤回消息 -->
            <div v-if="recallData.userName" class="recall-box already-recall">
              <span class="recall">{{ recallData.userName }}已撤回一条消息</span>
            </div>
            <div id="scrollBottom"></div>
          </vue-scroll>
          <!-- 底部栏 -->
          <div class="input-box">
            <div class="box-icon" v-if="!disableMsgInput && activeName == 'four'" @click="joinVedioRoom">
              <span class="vedio-icon"></span>
            </div>
            <div class="box-icon">
              <inputOver v-if="!readonly" :popoverList="overusePopoverList" iconClass="el-icon-info"
                @closePopver="closeOverPopver" :visiblePop="visibleOverPop" :popverWidth="popveOverWidth"
                @sendOveruse="sendOveruse" @changeInput="changeOveroutInput" @addSentence="addSentence"
                @updateSentence="updateSentence" @deleteSentence="deleteSentence" @saveSentence="saveSentence"
                :showAdd="isSaveSentence" :showUpdateId="isUpdateSentenceId" @updateSaveSentence="updateSaveSentence"
                @cancelAddSave="cancelAddSave"></inputOver>
              <div v-else class="iconfont iconwenjuan" style="color: #666;font-size: 25px"></div>
            </div>
            <div class="box-icon" v-if="showAdd && activeName !== 'second'">
              <inputMore v-if="!readonly" :popoverList="morePopoverList" iconClass="el-icon-circle-plus-outline"
                :popverWidth="popveMoreWidth" @openMore="openMore" @closePopver="closeMorePopver"
                :visiblePop="visibleMorePop" @uploadFile="uploadFile" :isEndConsultation="isEndConsultation"
                @endConsultation="endConsultation"></inputMore>
              <!-- 其他疗管在回复，锁定当前房间 -->
              <div v-else class="el-icon-circle-plus-outline bbb" style="color: #666;"> </div>
            </div>
            <div class="input-content">
              <el-input ref="sendInput" maxlength="500" v-model="textMsg" :disabled="disableMsgInput||readonly" type="textarea"
                :placeholder="disableMsgInput?'历史对话仅可查看，不可发送消息':readonly ? answer:'请输入你想说的话'" class="input"
                :autosize="{ minRows: 1, maxRows: 2 }" @focus="sendInput('input')" @blur="unlockRoom('blur')"
                @keydown.enter.native="carriageReturn($event)"></el-input>
              <!--  @keyup.enter.native="onSubmit" -->
              <!-- @keypress.native.enter="onEnterPress" -->
            </div>
            <div v-if="!disableMsgInput" class="box-icon biaoqing" style="margin-top: 5px">
              <el-popover v-if="!readonly" @show='sendInput' @hide="unlockRoom('emoji')" placement="top-end" width="446"
                trigger="click" ref="popverEmojRef" popper-class="popverEmojClass">
                <div class="emej">
                  <img class="emej-image" :src="require(`../../static/face/${em.url}`)" v-for="(em, eid) in emojiList"
                    :key="eid" @click="addEmoji(em)" :title="em.alt" />
                </div>
                <div slot="reference" class="iconfont iconbiaoqing" style="color: #666;font-size: 25px"></div>
              </el-popover>
              <div v-else class="iconfont iconbiaoqing" style="color: #666;font-size: 25px"></div>
            </div>
            <div>
              <el-button type="primary" v-if="pageName=='case-4'" style="background:#1A7BFC" size="small"
                @click="docSendText">发 送</el-button>
              <el-button type="primary" :disabled="disableMsgInput || readonly"
                :style="{background:disableMsgInput ? '#BBBBBB' : '#1A7BFC',borderColor:disableMsgInput ? '#BBBBBB' : '#1A7BFC'}"
                v-else size="small" @click="sendText">发送</el-button>
            </div>
          </div>
        </template>
        <!-- 顶部异常提醒 -->
        <div class="sign" v-if="IMInfo.patientAnomalyList">
          <div class="sign-item" v-for="(item, key) in patientAnomalyList" :key="item.id">
            <div class="item-left">
              <i class="el-icon-warning"></i>
              <span>{{ item.remind }}</span>
            </div>
            <span class="item-close" @click="signClose(item, key)"><i class="el-icon-close"
                style="color: #787E85;font-size: 12px"></i></span>
          </div>
        </div>
      </div>
      <!-- 在线教程 -->
      <el-dialog title="在线教程" :visible.sync="onlineJia" center @close='currentId = 0'>
        <div style="display:flex">
          <div class="im-dialog-content">
            <div class="dialog-search">
              <el-input style="width:610px" placeholder="请输入内容章节标题" clearable maxlength="20"
                prefix-icon="el-icon-search" size="small" v-model="keyWord"></el-input>
              <p>
                <el-button @click="restSearch" size="small">重置</el-button>
                <el-button type="primary" @click="onSearch" size="small">搜索</el-button>
              </p>
            </div>
            <el-table @selection-change="handleSelectionCourse" :data="onlineJiaTable"
              :header-cell-style="{ textAlign: 'center', color: '#333333',fontSize: '14px',fontWeight: 'bold', backgroundColor: '#FAFAFA'}">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="courseName" label="教程名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="diseaseType" label="病种" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="章节标题" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="belongTo" label="归属" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="currentId = scope.row.id">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="im-cardpage">
              <el-pagination background @size-change="onlineJiaPageSize" @current-change="onlineJiaCurrentChange"
                :current-page="onlineJiaCurrent" :page-size='courseSize' :page-sizes="onlineJiaPage"
                layout="total, sizes, prev, pager, next, jumper" :total="onlineJiaTotal">
              </el-pagination>
            </div>
          </div>
          <div v-if="currentId" class="dialog-look">
            <iframe :src="'/phone2.html?id=' + currentId" width="100%" height="100%" frameborder="0"></iframe>
          </div>
        </div>
        <div slot="footer" class="multi-send">
          <el-button @click="onlineJia = false" size="small">关闭</el-button>
          <el-button @click.native.prevent="onlineCourseSend()" :loading='sendLoding' type="primary" size="small">
            {{sendLoding?'发送中':'发送'}}
          </el-button>
        </div>
      </el-dialog>

      <!-- 宣传患教 -->
      <el-dialog title="健康宣教" :visible.sync="promoting" custom-class="set-health-article" center @close="currentId = 0">
        <div style="display:flex">
          <div class="im-dialog-content">
            <div class="dialog-search">
              <el-input style="width:610px" placeholder="请输入宣教标题/主适配病种" v-model="contentSearch" clearable
                size="small"></el-input>
              <p>
                <el-button size="small" @click="restMission">重置</el-button>
                <el-button type="primary" size="small" @click.stop="getMission">搜索</el-button>
              </p>
            </div>
            <el-table @selection-change="handleSelectionCourse" height="550" :data="promotingTable"
              :header-cell-style="{ textAlign: 'center', color: '#333333',fontSize: '14px',fontWeight: 'bold', backgroundColor: '#FAFAFA'}">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="title" label="宣教标题" show-overflow-tooltip align="center"> </el-table-column>
              <el-table-column label="类型" align="center" show-overflow-tooltip>
                <template
                  slot-scope="scope">{{ scope.row.missionType == 1 ? '推荐' : scope.row.missionType == 2 ? '提醒' : scope.row.missionType == 3 ? '辅导' : '' }}</template>
              </el-table-column>
              <el-table-column prop="diseaseTypeName" label="主适配病种" show-overflow-tooltip
                align="center"></el-table-column>
              <el-table-column prop="belongTo" label="归属" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleLookArticle(scope.row)" size="small">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="im-cardpage">
              <el-pagination background @size-change="promotingPageSize" @current-change="promotingCurrentChange"
                :current-page="promotingCurrent" :page-size='promotingSize' :page-sizes="onlineJiaPage"
                layout="total, sizes, prev, pager, next, jumper" :total="promotingTotal">
              </el-pagination>
            </div>
          </div>
          <div v-if="currentId" class="phone-container" style="width:500px">
            <iframe :src="'/phone.html?id=' + currentId" scrolling="no" style="width:100%;height:100%"
              frameborder="0"></iframe>
          </div>
        </div>
        <div slot="footer" class="multi-send">
          <el-button @click="promoting = false" size="small">关闭</el-button>
          <el-button @click.native.prevent="promotingSend()" :loading='sendLoding' type="primary" size="small">
            {{sendLoding?'发送中':'发送'}}
          </el-button>
        </div>
      </el-dialog>

      <div class="dialog">
        <!-- 问卷选择--发送 -->
        <addQuestionDialog v-if="questionCom.visible" :showAddQuestion.sync="questionCom.visible"
          :hospitalId="IMInfo.hospitalId" :title="questionCom.title" @receiveQuestion="receiveQuestion"
          :newHospitalId='newHospitalId' />
        <!-- 问题问卷 -->
        <el-dialog title="问题问卷" :visible.sync="questionpaper" v-if="questionpaper" width="50%" center>
          <!-- 表格数据 -->
          <el-table :data="questionTable" style="width: 100%" max-height="500">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="id" label="ID" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="title" label="名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="examTypeName" label="类型" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button @click.native.prevent="questionSend(scope.$index, scope.row)" type="text" size="small"
                  style="color:#1A7BFC">
                  发送
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="im-cardpage">
            <el-pagination background @size-change="questionPageSize" @current-change="questionCurrentChange"
              :current-page="questionCurrent" :page-size="questionPage" layout="total,  prev, pager, next, jumper"
              :total="qusetionTotal">
            </el-pagination>
          </div>
        </el-dialog>
        <!-- 评估量表 -->
        <el-dialog title="评估量表" :visible.sync="assessment" width="50%" center>
          <!-- 表格数据 -->
          <el-table :data="assessmentTable" style="width: 100%" max-height="500">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="id" label="ID" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tagName" label="类型" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button @click.native.prevent="assessmentSend(scope.$index, scope.row)" type="text" size="small">
                  发送
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="im-cardpage">
            <el-pagination background @size-change="assessmentPageSize" @current-change="assessmentCurrentChange"
              :current-page="assessmentCurrent" :page-size="assessmentPage" layout="total,  prev, pager, next, jumper"
              :total="assessmentTotal">
            </el-pagination>
          </div>
        </el-dialog>
        <!-- 数据表单 -->
        <!-- 随访记录表 -->
        <el-dialog title="随访记录" :visible.sync="questionpaperone" size="50%" center>
          <BaseTable size="mini" border stripe :data="tableData" :column="tabListConfig" pagination :auto-scroll="true"
            :total="totalPage" :page.sync="listQuery.current" :limit.sync="listQuery.size" @pagination="getList">
          </BaseTable>
          <el-drawer :append-to-body="true" center :visible.sync="innerDrawer">
            <div class="dis">
              <div class="">
                <el-scrollbar style="width: 100%; border-radius: 15px">
                  <iframe src="https://sit-survey.dsicm.com/surveys/150080/demo" width="360" height="580"
                    frameBorder="{0}"></iframe>
                </el-scrollbar>
              </div>
            </div>
          </el-drawer>
        </el-dialog>

        <!-- 患者反馈评估问卷 -->
        <patFeedbackAssQuesDialog v-if="patFeedbackAssQues.visible" :showAddQuestion.sync="patFeedbackAssQues.visible"
          :title="patFeedbackAssQues.title" :tabListConfig="patFeedbackAssQues.tabListConfig"
          @receiveQuestion="receiveQuestion" />

        <!-- 发送服务 -->
        <serviceRecommon v-if="serviceRecommon.visible" :showAddQuestion.sync="serviceRecommon.visible"
          :title="serviceRecommon.title" :param="IMInfo" :topHospitalId="IMInfo.hospitalId"
          @receiveQuestion="receiveQuestion" />
           <!-- 落地页选择-->
        <landPageSelect v-if="landPageObj.visible" :showAddQuestion.sync="landPageObj.visible"
          :title="landPageObj.title" :param="IMInfo"/>  
        <!-- 病历夹发送 dossierSelect -->
        <el-dialog title="病历夹发送编辑" custom-class="dossier-dialog" :visible.sync="dossier.visible" width="40%"
          :before-close="dossierHandleClose">
          <div class="dossier-box">
            <el-form :model="dossier" :rules="dossierRules" ref="dossierRuleForm" label-width="60px" label-suffix=":"
              class="demo-ruleForm">
              <el-form-item label="标题" prop="title">
                <el-input placeholder="最多输入10个字" maxlength="10" size="mini" v-model="dossier.title" clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="正文" prop="content">
                <el-input type="textarea" size="mini" :rows="3" placeholder="请输入正文" v-model="dossier.content"
                  maxlength="50" show-word-limit clearable>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dossierReset('dossierRuleForm')">重 置</el-button>
            <el-button type="primary" size="mini" @click="patientCasePush('dossierRuleForm')">发 送</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 患者图片放大预览 -->
      <el-dialog v-if="previewPictures" title="图片操作" :visible.sync="previewPictures" :close-on-click-modal="false"
        width="650px" center>
        <div v-loading="leftFlag || rightFlag || preFlag || nextFlag">
          <div class="viewer-pic">
            <div style="text-align:center;line-height:40px" v-if="!editPicStatus">{{localBodyName}}
              <i v-if="routerName!='consultRoom'" class="el-icon-edit" @click="editPicName"></i>
            </div>
            <div style="display:flex">
              <el-input v-if="editPicStatus" style="width:350px" maxlength="20" v-model="localBodyName"></el-input>
              <i v-if="editPicStatus" class="el-icon-check" @click="savePicName"></i>
            </div>
            <el-button type="primary" v-if="routerName!='consultRoom'"
              @click="moveReference(previewPicturesUrl)">对照录入</el-button>
          </div>
          <div style="overflow:hidden">
            <div class="image-preview" @mousedown="move" @mousewheel="handleZoomImg"
              :style="{backgroundImage: 'url(' + imgOss + previewPicturesUrl + ')', 
              backgroundSize:'contain',
              backgroundPosition:'center',
              backgroundRepeat: 'no-repeat','transform': `rotate(${rightcountDeg}deg) scale(${(zoomIndex /10) * 1})`,}">
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="preImage">上一张</el-button>
            <el-button @click="nextImage">下一张</el-button>
            <el-button @click="leftRotate">左旋转</el-button>
            <el-button @click="rightRotate">右旋转</el-button>
            <!-- <el-button @click="previewPictures = false">取 消</el-button> -->
            <!-- <el-button type="primary" @click="moveReference(previewPicturesUrl)"
              >对照录入</el-button> -->
          </div>
        </div>
      </el-dialog>
      <!--  医生历史图片放大预览 -->
      <el-dialog title="查看图片" :visible.sync="previewPicturesDoctor" width="50%" center>
        <img :src="previewDoctorUrl" alt="" style="height: 100%; width: 100%" />
      </el-dialog>
      <!--  个案历史图片放大预览 -->
      <el-dialog title="查看图片" :visible.sync="bigIndividualDialog" width="50%" center>
        <img :src="bigIndividualUrl" alt="" style="height: 100%; width: 100%" />
      </el-dialog>
      <audio id="audio_id" style="display: none;" muted loop>Your browser can't support HTML5 Audio</audio>
    </div>
    <!-- <div v-else style="height:100%;overflow:auto;padding:20px">
      <QuestionList ref="dialogRef" :paramDataObj="paramData" :wholeCourseId="wholeCourseId" :payloadData="payloadData"
        :feedBackItem="feedBackItem" :imLook="imLookStatus">
      </QuestionList>
      <el-button size="mini" type="primary" class="back-im" @click="backToIM">返回IM</el-button>
    </div> -->
    <!-- 问卷列表弹框 -->
    <div class="custom-34">
      <div v-if="detailVisible" class="more-detail-modal" v-loading='loadList'>
        <div class="more-detail">
          <div v-if="detailData.missionVOS && detailData.missionVOS.length">
            <div class="health-ed info-content-flex" v-for="(item, key) in detailData.missionVOS" :key="key">
              <img src="@/assets/images/xj.png" alt="">
              <div class="title">{{ item.title }}</div>
            </div>
          </div>

          <div v-if="detailData.qsExamPaperVOS && detailData.qsExamPaperVOS.length">
            <div class="question-ed info-content-flex" v-for="(item, key) in detailData.qsExamPaperVOS" :key="key">
              <div class="question-left">
                <img src="@/assets/images/wj.png" alt="">
                <div>
                  <div class="title">{{ item.title }}</div>
                  <div class="question-left-content">{{ item.startRemark }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="detailData.trainChapterVOS && detailData.trainChapterVOS.length">
            <div class="train-ed info-content-flex" v-for="(item, key) in detailData.trainChapterVOS" :key="key">
              <img src="@/assets/images/kf.png" alt="">
              <div class="title">{{ item.name }}</div>
            </div>
          </div>
          <span class="close" @click="closeTrain"><i class="el-icon-error"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionList from "../RightContent/questionList";
import {
  queryList,
  pushExamPaperSingle,
  getCustomerService
} from "@/api/questionnaireManage";
import {
  getOveroutList,
  addOverout,
  updateOverout,
  deleteOverout
} from "../../api/overoutApi.js";
import { imgBaseURL } from "@/utils/common";
import {
  apiGgetRecordByRoomCode,
  patientAnomalyClose,
  sendTimMessage,
  setCustomName,
  nextImage,
  preImage,
  reportOrderPush,
  gethealthRecommendData
} from "../../api/index.js";
import { questionColumn, patfeedbackColumn } from "../DocNur/config/index";
import {
  sendDelayEnd,
  pushMissionIMNew,
  getMissonList,
  api_getInquiryList,
  api_sendTimText,
  api_post_addTofoles,
  getChapter,
  getMissionData,
  mission_push_batch,
  chapter_push_batch,
  api_getintoInquiryRoom,
  getReadySequence,
  getReadyDocSequence,
  specialFileUpdate,
  api_sendDocter,
  getOnlineCount,
  synergyDetails,
  chatRecordRecall, // im文本消息撤回
  patientCaseHistoryPush // 病历夹推送
} from "@/api/apiIM.js";
import axios from "axios";
// 查看
import { questionnaireDetails } from "@/api/questionnaireManage";
import tim from "@/commen/tim/tim.js";
import moment from "moment";
import { selectSurveys } from "@/api/acc";
import ShowVideo from "../../../SystemSettings/component/video.vue";
import { jsonp } from "vue-jsonp";
export default {
  props: {
    IMInfo: {
      type: Object,
      default: () => {}
    },
    pageType: {
      type: String | Number,
      default: ""
    },
    topHeight: {
      type: Number,
      default: 40
    },
    hasSonEmit: {
      type: Boolean,
      default: false
    },
    showAdd: {
      type: Boolean,
      default: true
    },
    showReadStatus: {
      type: Boolean,
      default: true
    },
    pageName: {
      type: String,
      default: ""
    },
    chatPatientName: {
      type: String,
      default: ""
    },
    routerName: {
      type: String,
      default: ""
    },
    tabClickName: {
      type: String,
      default: ""
    }
  },
  data() {
    const ops = {
      vuescroll: {
        mode: "native",
        sizeStrategy: "percent",
        detectResize: true,
        /** 锁定一种滚动方向， 锁定的方向为水平或者垂直方向上滑动距离较大的那个方向 */
        locking: true,
        wheelScrollDuration: 0, //滚轮滚动一段距离所需时间。
        wheelDirectionReverse: false, //是否使滚轮方向相反
        checkShifKey: true //是否检测 shift 键位 具体请查看
      },
      scrollPanel: {
        initialScrollY: false,
        initialScrollX: false,
        scrollingX: false,
        scrollingY: true,
        speed: 300,
        easing: "easeInQuad",
        verticalNativeBarPos: "right",
        maxHeight: undefined,
        maxWidth: undefined
      },
      rail: {
        background: "#01a99a",
        opacity: 0,
        size: "6px",
        specifyBorderRadius: false,
        gutterOfEnds: null,
        gutterOfSide: "2px",
        keepShow: false
      },
      bar: {
        keepShow: false, // 是否保持滚动条显示
        size: "8px",
        opacity: 1,
        onlyShowBarOnScroll: false,
        background: "#DADADB" //#1A7BFC
      }
    };
    return {
      loadSend:false,
      curOnlineNum: 0,
      onlineNumTimer: null,
      isJoinVideoRoom: false, //是否可进去视频房间  问诊类型为视频问诊并且 状态为正在进行中的才可以进入视频房间
      synergyRoomCode: "", //会诊房间号
      bizUnionId: "", //会诊id
      showVideoRoom: false,
      sendLoding: false,
      multiSendList: [],
      courseSize: 10,
      promotingSize: 10,
      noLoad: false,
      // stopScroll: false,
      newHospitalId: "",
      keyWord: "",
      loadList: true,
      loadMore: true,
      detailData: {},
      detailVisible: false,
      disableMsgScroll: false,
      disableMsgInput: false,
      readonly: false,
      answer: "xxx",
      imLookStatus: false,
      payloadData: {},
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      paramData: {},
      showIm: true,
      // customName: '',
      directRotate: "",
      msgId: "",
      imgBaseURL: imgBaseURL,
      questionTypeId: "",
      patientInfo: Object.create(null), // 患者信息
      ops,
      // 更多功能的提示宽度
      popveMoreWidth: 500,
      // 常用语句的提示宽度
      popveOverWidth: 731,
      wholeCourseId: "",
      // 默认第一个（大房间）
      activeName: "first",
      currentTab: 0,
      // 消息IM 模块
      noData: false, // 加载中效果开关
      refresh: 1,
      textMsg: "", // 输入 发送的消息
      conversationID: "", // 房间号
      recordContent: [], // 消息数组
      doctorImg: process.env.VUE_APP_OSS_URL, //医生历史图片接受路径
      imgHead: require("../../static/headLogo.png"),

      // 消息的分页配置
      historySize: 15, //消息条数
      historyCurrent: 1,
      total: 0,
      unreadCount: 0, // 未读消息
      popoverList: [
        {
          id: 1,
          name: "在线教程",
          icon: require("../../static/IMInput/line.png")
        },
        {
          id: 2,
          name: "宣传患教",
          icon: require("../../static/IMInput/xuanchuan.png")
        }
      ],
      // im input 更多功能
      morePopoverList: [],
      // 常用语句的数组
      overusePopoverList: [],
      overusePopoverListArr: [],
      emojiList: this.$commen.emojiList,
      visibleMorePop: false, // 更多的气泡框控制
      visibleOverPop: false, // 常用语句的气泡框控制
      isMiniRoom: false,
      isCooperateIM: false, //协同会话问诊订单

      // 在线教程
      onlineJia: false, //在线教程弹出框显示隐藏
      onlineJiaPage: [10, 20, 30, 50], //每页条数
      onlineJiaCurrent: 1, // 初始显示那一页
      onlineJiaTotal: 0, // 总条数
      onlineJiaTable: [], //列表数据
      // 宣传患教
      promoting: false, //在线教程弹出框显示隐藏
      promotingCurrent: 1, // 初始显示那一页
      promotingTotal: 0, // 总条数
      promotingTable: [], //列表数据

      //问题问卷
      questionpaper: false, //问题问卷弹出框显示隐藏
      questionPage: 10, //每页条数
      questionCurrent: 1, // 初始显示那一页
      qusetionTotal: 0, // 总条数
      questionTable: [], //列表数据
      //评估量表
      assessment: false, //问题问卷弹出框显示隐藏
      assessmentPage: 10, //每页条数
      assessmentCurrent: 1, // 初始显示那一页
      assessmentTotal: 0, // 总条数
      assessmentTable: [], //列表数据
      //随访记录表
      questionpaperone: false, //问题问卷弹出框显示隐藏
      pageSizeone: 10, //每页条数
      currentPageone: 1, // 初始显示那一页
      totalone: 0, // 总条数
      tabListConfig: [
        {
          label: "序号",
          align: "center",
          fixed: "left",
          size: "mini",
          width: "50px",
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>;
          }
        },
        {
          label: "问卷ID",
          align: "center",
          prop: "id",
          size: "mini"
        },
        {
          label: "标题",
          align: "center",
          prop: "name",
          size: "mini"
        },
        // {
        //     label:'归属',
        //     align :'center',
        //     prop:"no" ,
        //     size:'mini'
        // },
        {
          label: "应用范围",
          align: "center",
          prop: "no3",
          size: "mini"
        },
        {
          label: "病种",
          align: "center",
          prop: "no4",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          prop: "no5",
          size: "mini",
          render: (h, scope) => {
            return (
              <div>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.hometHandel(scope, 1)}
                >
                  填报
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.hometHandel(scope, 2)}
                >
                  发送
                </el-button>
              </div>
            );
          }
        }
      ],
      innerDrawer: false,
      // 各种dialog放大
      previewPictures: false,
      previewPicturesDoctor: false,
      bigIndividualDialog: false,
      previewPicturesUrl: "", //查看大图图片路径
      localBodyName: "",
      editPicStatus: false,
      bigIndividualUrl: "", //个案图片路径
      previewDoctorUrl: "",
      listQuery: {
        current: 1,
        size: 10
      },
      tableData: [],
      totalPage: 0,
      userInfo: "", //保存问卷id和患者id
      fromId: "", //个案IM账号
      userSig: "",
      caseMgrGroupId: "",
      createRoomStatus: false,
      localBody: "",
      roomcodeId: "", // 结束咨询房间好的id（可以是问诊id
      isEndConsultation: false, // 是否显示结束问诊
      inquiryId: "", // 问诊id
      flagMessage: false,
      isSaveSentence: false, // 是否保存了常用语句
      isUpdateSentenceId: "", // 是否编辑
      sequence: "", // 判断是否是已读未读
      SetIntervalRes: null, // 轮询是否已读
      inquiryStatus: "",
      // 问卷选择
      questionCom: {
        visible: false,
        params: {}
      },
      // 患者反馈评估问卷
      patFeedbackAssQues: {
        visible: false,
        title: "问卷选择",
        tabListConfig: questionColumn // 问卷colmun
      },
      // 推荐服务
      serviceRecommon: {
        visible: false,
        title: "请选择服务",
        param: this.IMInfo // 问卷colmun
      },
     landPageObj: {
        visible: false,
        title: "推荐落地页"
      },
      // 病历夹
      dossier: {
        visible: false,
        title: "上传病历", // 标题
        content: "请上传您的病历，让我们能更好的为您服务。" // 内容
      },
      dossierRules: {
        title: [
          { required: true, message: "必须输入标题", trigger: "blur" },
          { min: 1, max: 10, message: "标题最多可输入10个字", trigger: "blur" }
        ],
        content: [{ required: true, message: "必须输入正文", trigger: "blur" }]
      },
      patientAnomalyList: [], // 异常提醒数据
      newDate: "",
      // leftcount: 0,
      rightcountDeg: 0,
      leftFlag: false,
      rightFlag: false,
      preFlag: false,
      nextFlag: false,
      feedBackItem: {},
      contentSearch: "",
      currentId: "",
      drawer: false,
      defaultIdType: "hospitalId",
      recallData: {},
      zoomIndex: 10
    };
  },
  components: {
    // 666
    videoRoom: () => import("../../src/videoRoom/index.vue"),
    QuestionList,
    // 异步组件，在需要的时候才需要解析组件结果缓存起来供未来重渲染。
    ShowVideo,
    patientTaskReminder: () =>
      import("../messageTypeCompnents/patientTaskReminder.vue"),
    textMsgComponent: () =>
      import("../messageTypeCompnents/textMsgComponent.vue"),
    imageMsg: () => import("../messageTypeCompnents/imageMsgComponent.vue"),
    audioMsg: () => import("../messageTypeCompnents/audioMsgComponent.vue"),
    fileMsg: () => import("../messageTypeCompnents/fileMsgComponent.vue"),
    inputMore: () => import("../IM-input-more/more.vue"),
    inputOver: () => import("../IM-input-more/overuse.vue"),
    customZeros: () => import("../messageTypeCompnents/custom-zeros.vue"),
    customOne: () => import("../messageTypeCompnents/custom-one.vue"),
    customTwo: () => import("../messageTypeCompnents/custom-two.vue"),
    customThree: () => import("../messageTypeCompnents/custom-three.vue"),
    customFour: () => import("../messageTypeCompnents/custom-four.vue"),
    customFive: () => import("../messageTypeCompnents/custom-five.vue"),
    customSix: () => import("../messageTypeCompnents/custom-sixs.vue"),
    customNorm: () => import("../messageTypeCompnents/custom-norm.vue"),
    customFurther: () => import("../messageTypeCompnents/custom-further.vue"),
    customTarget: () => import("../messageTypeCompnents/custom-target.vue"),
    customSymptom: () => import("../messageTypeCompnents/custom-symptom.vue"),
    customReports: () => import("../messageTypeCompnents/custom-reports.vue"),
    customSeven: () => import("../messageTypeCompnents/custom-seven.vue"),
    customEight: () => import("../messageTypeCompnents/custom-eight.vue"),
    customNine: () => import("../messageTypeCompnents/custom-nines.vue"),
    customTwelve: () => import("../messageTypeCompnents/custom-twelve.vue"),
    customThirteen: () => import("../messageTypeCompnents/custom-thirteen.vue"),
    customTest: () => import("../messageTypeCompnents/custom-test.vue"),
    customFourteen: () => import("../messageTypeCompnents/custom-fourteen.vue"),
    customTwenty: () => import("../messageTypeCompnents/custom-twenty.vue"),
    customTwentytwo: () =>
      import("../messageTypeCompnents/custom-twentytwo.vue"),
    customSeventeen: () =>
      import("../messageTypeCompnents/custom-seventeen.vue"),
    customSixteen: () => import("../messageTypeCompnents/custom-sixsteen.vue"),
    customEighteen: () => import("../messageTypeCompnents/custom-eighteen.vue"),
    // customNineteen: () =>import('../messageTypeCompnents/custom-nineteen.vue'),
    customNighteen: () => import("../messageTypeCompnents/custom-nighteen.vue"),
    customFiles: () => import("../messageTypeCompnents/custom-files.vue"),
    customTwentyfour: () =>
      import("../messageTypeCompnents/custom-twentyfour.vue"),
    customTwentythree: () =>
      import("../messageTypeCompnents/custom-twentythree.vue"),
    customTwentyfive: () =>
      import("../messageTypeCompnents/custom-twentyfive.vue"),
    customThirtyseven: () =>
      import("../messageTypeCompnents/custom-thirtyseven.vue"),
    customTwentysix: () =>
      import("../messageTypeCompnents/custom-twentysix.vue"),
    // 问诊订单
    customTwentyseven: () =>
      import("../messageTypeCompnents/custom-twentyseven.vue"),
    // 问诊订单已支付
    customTwentyeight: () =>
      import("../messageTypeCompnents/custom-twentyeight.vue"),
    // 填写主诉
    customTwentynine: () =>
      import("../messageTypeCompnents/custom-twentynine.vue"),
    // 主诉填写完成
    customThirty: () => import("../messageTypeCompnents/custom-thirty.vue"),
    // 康复评估报告
    customThirtytwo: () =>
      import("../messageTypeCompnents/custom-thirtytwo.vue"),
    // 推送病历夹
    customThirtyone: () =>
      import("../messageTypeCompnents/custom-thirtyone.vue"),
    // 推送义诊卡片
    customThirtyfive: () =>
      import("../messageTypeCompnents/custom-thirtyfive.vue"),
    // 症状反馈卡片
    customSymptomfeedback: () =>
      import("../messageTypeCompnents/custom-symptomfeedback.vue"),
    customThirtythree: () =>
      import("../messageTypeCompnents/custom-thirtythree.vue"),
    customThirtyfour: () =>
      import("../messageTypeCompnents/custom-thirtyfour.vue"),
    createMiniRoom: () => import("../CreateRoom/index.vue"),
    cooperateIM: () => import("../CreateRoom/cooperateIm.vue"),
    patFeedbackAssQuesDialog: () => import("../DocNur/addQuestionDialog.vue"), // 患者反馈评估问卷
    addQuestionDialog: () =>
      import("@/views/ToolMaintenance/component/imAddQuestionDialog.vue"), // 问卷选择
    serviceRecommon: () => import("../serviceRecommon"), // 服务推荐
    landPageSelect:() => import("../landPageSelect"), // 落地页选择
    questionDialog: () => import("../question/addQuestionDialog.vue"),
    // 2.2.0新增的系统消息部分卡片
    customSyone: () => import("../messageTypeCompnents/custom-syone.vue"),
    customSytwo: () => import("../messageTypeCompnents/custom-sytwo.vue"),
    customSythree: () => import("../messageTypeCompnents/custom-sythree.vue"),
    customSyfour: () => import("../messageTypeCompnents/custom-syfour.vue"),
    customSyfive: () => import("../messageTypeCompnents/custom-syfive.vue"),
    customSysix: () => import("../messageTypeCompnents/custom-sysix.vue"), 
    customTemplate: () => import("../messageTypeCompnents/custom-template.vue"),
    customSyeight: () => import("../messageTypeCompnents/custom-syeight.vue"),
    customSynine: () => import("../messageTypeCompnents/custom-synine.vue"),
    customSyten: () => import("../messageTypeCompnents/custom-syten.vue")
  },
  computed: {},
  watch: {
    tabClickName: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            //协同订单进入 房间时 房间号设置为协同会话房间号
            this.activeName = "four";
            this.synergyRoomCode = val;
          });
        }
      }
    },
    synergyId: {
      immediate: true,
      handler(val) {
        if (val) { 
          this.$nextTick(() => {
            //协同订单进入 房间时 获取会诊id ，获取会诊详情
            this.bizUnionId = val;
            this.getSynergyDetails();
          });
        }
      }
    },
    IMInfo: {
      deep: true,
      handler(oldVal, newVal) {
        if (oldVal !== newVal) {
          this.showIm = true;
          this.IMInfo = oldVal; //为了处理什么呢？？？
          this.conversationID = this.IMInfo.imId?.slice(5);
          this.$store.commit("GROUP_CODE", this.IMInfo.imId?.slice(5));
          this.$store.commit("PATIENT_ID", this.IMInfo.patientId);
          this.disableMsgInput = false;
          // 切换患者将activeName设为默认first
          // 是服务跳转的话切换至服务咨询当前tab是医护对话则跳转至大房间 否则保持不变 oldVal.isService
          if (
            ((!newVal || (newVal.imId !== oldVal.imId && !oldVal.isService)) &&
              !this.tabClickName) ||
            (oldVal.isService && oldVal.noThird && this.activeName === "third")
          ) {
            this.activeName = "first";
            this.currentTab = 0;
            // 数据切换到第一个
            this.isMiniRoom = false;
            this.isCooperateIM = false;
          }

          if (
            this.$route.params.roomLevel === 4 ||
            this.$store.state.patientObj.roomLevel === 4
          ) {
            this.activeName = "third";
            this.docInitData();
            // 在caseGroupRoomId发生改变时调用
            this.$socket.emit(
              "setGroupCode",
              this.IMInfo.caseGroupRoomId?.slice(5),
              data => {}
            );
          }
          setTimeout(() => {
            this.historyCurrent = 1;
            this.setIntervalReady();
            if (this.activeName == "third") {
              // 医护对话
              if (
                !newVal ||
                newVal.caseGroupRoomId !== oldVal.caseGroupRoomId
              ) {
                this.docInitData();
                // 在caseGroupRoomId发生改变时调用
                this.$socket.emit(
                  "setGroupCode",
                  this.IMInfo.caseGroupRoomId?.slice(5),
                  data => {}
                );
              }
            } else if (this.activeName == "first") {
              //当前会话
              if (
                !newVal ||
                newVal.imId !== oldVal.imId ||
                oldVal.upFlag ||
                oldVal.messageUp
              ) {
                this.initData();
                // 在imId发生改变时调用 或者 从全局消息列表进入调用
                this.$socket.emit(
                  "setGroupCode",
                  this.IMInfo.imId?.slice(5),
                  data => {}
                );
              }
            } else if (this.activeName == "second") {
              //专项会话
              this.isMiniRoom = true;
              this.disableMsgInput = true;
              this.wholeCourseId = this.IMInfo.id || this.IMInfo.wholeCourseId;
              let groupCode = this.IMInfo.imId;
              if (this.IMInfo.imId) {
                groupCode = this.IMInfo.imId.slice(5);
              }
              this.$socket.emit("setGroupCode", groupCode, data => {});
            } else {
              //协同会话
              this.initData();
              this.$socket.emit(
                "setGroupCode",
                this.synergyRoomCode,
                data => {}
              );
            }
          }, 200);
          this.wholeCourseId = this.IMInfo.id || this.IMInfo.wholeCourseId;
          this.$store.commit("WHOLE_COURSE_ID", this.wholeCourseId);
          this.patientAnomalyList = this.IMInfo.patientAnomalyList;
          this.visibleMorePop = false;
          this.visibleOverPop = false;
          this.textMsg = "";
          this.unLock();
          this.getInitData();
        }
      },
      immediate: true
    },
    "IMInfo.patientAnomalyList"(val) {
      this.patientAnomalyList = val;
    }
  },
  sockets: {
    disconnect() {},
    reconnect() {
      setTimeout(() => {
        if (this.$store.state.rightTypeParams.rightType) {
          let end = this.$store.state.rightTypeParams;
          this.$socket.emit("setRightParams", JSON.stringify(end), data => {});
        }
        setTimeout(() => {
          this.$socket.emit(
            "setGroupCode",
            this.IMInfo.imId?.slice(5),
            data => {}
          );
        }, 2000);
      }, 2000);
    },
    async imMessage(data) {
      if (!this.detailVisible) {
        this.inModal(false);
      }
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      // 客服消息管理
      if (this.pageName == "case-4") {
        // 刷新左侧患者列表
        this.$emit("refreshPatientList");
      }
      let list = await this.mapList(data.data.records, true);
      //接受到消息为当前房间时在更新聊天记录
      if (
        (this.activeName == "four" &&
          list[0].groupCode == this.synergyRoomCode) ||
        list[0].groupCode == this.IMInfo.imId?.slice(5)
      ) {
        this.total = data ? data.total : 0;
        this.recordContent = list;
        // 接收新的消息时置空原始撤回消息
        this.recallData = {};
        this.scrollToBottom();
      }
    },
    recall(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      data.account.indexOf(localStorage.getItem("userid")) > -1
        ? (data.userName = "您")
        : "";
      this.recallData = data;
      this.recordContent.map((item, key) => {
        if (item.msgSeq === data.msgSeq) {
          this.recordContent.splice(key, 1);
        }
      });
    },
    //锁定||解锁房间
    //切换房间就会触发此事件
    readonly(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
        if (data.groupCode == this.IMInfo.imId?.slice(5)) {
          this.readonly = data.readonly;
          this.answer = data.msg;
        }
      }
    }
  },
  async created() {
    await this.getInitData();
  },
  mounted() {
    this.getReadySe();
    if (this.currentTab == 1) {
      if (this.serviceCode == 3) {
        this.isEndConsultation = true;
      } else {
        this.isEndConsultation = false;
      }
    } else {
      this.isEndConsultation = false;
    }
  },
  methods: {
    //获取房间在线人数
    getOnlineCount() { 
      let params = {
        bizType: "synergy",
        id: this.bizUnionId
      }; 
      getOnlineCount(params).then(res => {
        if (res.code == 0) {
          this.curOnlineNum = res.data;
        }
      });
    },
    joinVedioRoom() {
      if (!this.isJoinVideoRoom) {
        this.$message.error("仅进行中的视频问诊才可加入视频房间！");
        return;
      }
      clearInterval(this.onlineNumTimer)
      this.showVideoRoom = true;
    },
    //返回上一级
    fourBack() {
      clearInterval(this.onlineNumTimer)
      this.isCooperateIM = true;
    },
    // 加入房间
    joinVideo(val) {
      this.bizUnionId = val.synergyId;
      //大房间卡片进入小房间时带房间号，协同会话房间未带入，从列表获取即可
      if (val.groupCode) {
        this.synergyRoomCode = val.groupCode;
      }
      this.joinVedioRoom();
    },
    //退出问诊
    outVideoRoom() {
      this.showVideoRoom = false;
      this.startTimer()
    },
    // 选择在线教程 || 健康宣教
    handleSelectionCourse(val) {
      this.multiSendList = val;
    },
    //通知有疗管正在回复
    sendInput(val) {
      if (val == "input") {
        this.visibleMorePop = false;
        this.visibleOverPop = false;
      }
      this.$socket.emit("inputting", this.IMInfo.imId?.slice(5), data => {});
    },
    unlockRoom(val) {
      if (val == "blur") {
        if (this.textMsg == "") {
          this.unLock();
        }
      } else {
        if ((val = "emoji")) {
          if (!(this.visibleMorePop || this.visibleOverPop)) {
            this.unLock();
          }
        } else {
          this.unLock();
        }
      }
    },
    unLock() {
      this.$socket.emit("unlock", "", data => {});
    },
    move(e) {
      let odiv = e.target; //获取目标元素

      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX - 25;
        let top = e.clientY - disY - 114;

        // //绑定元素位置到positionX和positionY上面
        // this.positionX = top;
        // this.positionY = left;

        //移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    handleZoomImg(e) {
      this.isPreview = true;
      e = e || window.event;

      // 火狐下没有wheelDelta，用detail代替，由于detail值的正负和wheelDelta相反，所以取反
      e.delta = e.wheelDelta || -e.detail;

      e.preventDefault();
      if (e.delta > 0) {
        //当滑轮向上滚动时
        this.scaleFunc(2);
      }
      if (e.delta < 0) {
        //当滑轮向下滚动时
        this.scaleFunc(-2);
      }
    },
    // 图片缩放
    scaleFunc(num) {
      // 这里设置了一个缩小倍数限制，最小缩小到0.2呗
      if (this.zoomIndex <= 2 && num < 0) return;
      // this.zoomIndex += num
      this.zoomIndex = this.zoomIndex + num;
    },
    restSearch() {
      this.keyWord = "";
      this.defaultIdType = "hospitalId";
    },
    restMission() {
      this.contentSearch = "";
      this.defaultIdType = "hospitalId";
    },
    closeDetails() {
      this.detailVisible = false;
      this.loadMore = true;
      this.detailData = {};
    },
    showDetailsList(data) {
      //处理多次点击加载更多
      if (this.loadMore) {
        this.detailMore(data);
      }
    },
    //类型卡片  31 查看更多
    async detailMore(obj) {
      this.inModal(true);
      this.loadList = true;
      this.loadMore = false;
      this.detailVisible = true;
      this.detailData = {};
      let { code, data } = await gethealthRecommendData({
        refId: obj.refId,
        refType: obj.refType,
        relatePushCollectionId: obj.relatePushCollectionId,
        patientId: this.$store.state.patientId
      });
      if (code === 0) {
        this.detailData = data;
      }
      this.loadList = false;
      this.loadMore = true;
    },
    closeTrain() {
      this.detailVisible = false;
      this.inModal(false);
    },
    // 返回右键菜单是否满足可展示条件
    checkMenuIsShowByCreateTime(data) {
      if (!data.createTime) return false;
      const informationExpirationTime =
        new Date(data.createTime).getTime() + 120 * 1000;
      const nowTime = Date.now();
      if (informationExpirationTime < nowTime) return false;
      return true;
    },
    // 撤回
    async handleWithdraw(scope, item) {
      // 调用组件撤回方法
      // 调用撤回接口
      let { code, data } = await chatRecordRecall({
        groupCode:
          this.activeName == "third"
            ? this.IMInfo.caseGroupRoomId?.slice(5)
            : this.IMInfo.imId?.slice(5),
        msgSeq: item.msgSeq
      });
      if (code === 0) {
        scope.opt.closeMenu();
      }
    },
    backToIM() {
      this.showIm = true;
      this.$emit("changeShowIm", true);
    },
    changeShowIm(data, data1, data2, data3) {
      this.paramData = data;
      this.feedBackItem = data1;
      this.showIm = false;
      this.payloadData = data2;
      this.imLookStatus = data3;
      this.$emit("changeShowIm", false);
    },
    editPicName() {
      this.editPicStatus = true;
    },
    async savePicName() {
      if (!this.localBodyName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      let res = await setCustomName({
        id:
          this.msgId.substring(0, 1) === "A"
            ? this.msgId.substring(1)
            : this.msgId,
        name: this.localBodyName,
        localBody: this.localBody,
        wholeCourseId: this.wholeCourseId
      });
      if (res.code === 0) {
        this.editPicStatus = false;
      }
    },
    leftRotate() {
      if (this.leftFlag) return;
      this.leftFlag = true;
      if (!this.localBodyName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      if (this.rightcountDeg === 0) {
        this.rightcountDeg = 360;
      }
      this.rightcountDeg = this.rightcountDeg - 90;
      this.directRotate = "left";
      // let filePath = 'tim-image/78867d4cb7f14d61af2cef292b424222.jpg?x-oss-process=image/rotate,90'
      let filePath;
      if (this.localBody.indexOf("/rotate,") != -1) {
        filePath = this.localBody.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath =
          this.localBody + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      setCustomName({
        id:
          this.msgId.substring(0, 1) === "A"
            ? this.msgId.substring(1)
            : this.msgId,
        name: this.localBodyName,
        localBody: filePath,
        wholeCourseId: this.wholeCourseId
      }).then(res => {
        if (res.code == 0) {
          this.leftFlag = false;
        }
      });
    },
    rightRotate() {
      if (this.rightFlag) return;
      this.rightFlag = true;
      if (!this.localBodyName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      if (this.rightcountDeg === 360) {
        this.rightcountDeg = 0;
      }
      this.rightcountDeg = this.rightcountDeg + 90;
      this.directRotate = "right";
      let filePath;
      // this.rightcountDeg = 0
      if (this.localBody.indexOf("/rotate,") != -1) {
        filePath = this.localBody.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath =
          this.localBody + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      setCustomName({
        id:
          this.msgId.substring(0, 1) === "A"
            ? this.msgId.substring(1)
            : this.msgId,
        name: this.localBodyName,
        localBody: filePath,
        wholeCourseId: this.wholeCourseId
      }).then(res => {
        if (res.code == 0) {
          this.rightFlag = false;
        }
      });
    },
    // 上一张图片
    async preImage() {
      if (this.preFlag) return;
      this.preFlag = true;
      // this.rightcountDeg = 0;
      let res = await preImage({
        id:
          this.msgId.substring(0, 1) === "A"
            ? this.msgId.substring(1)
            : this.msgId
      });
      if (res.code === 0) {
        this.preFlag = false;
        if (!res.data) {
          this.$message.warning("已是第一张");
          return;
        } else {
          this.rightcountDeg = 0;
        }
        this.msgId = res.data.id;
        if (res.data.customName) {
          this.localBodyName = res.data.customName;
        } else {
          this.localBodyName = res.data.localBody.split("/")[1];
        }
        // 有旋转角度的
        if (res.data.localBody.indexOf("/rotate,") != -1) {
          this.rightcountDeg = Number(res.data.localBody.split("/rotate,")[1]);
        }
        this.previewPicturesUrl = res.data.localBody.split(
          "?x-oss-process=image"
        )[0];
        this.localBody = res.data.localBody;
      }
    },
    // 下一张图片
    async nextImage() {
      if (this.nextFlag) return;
      this.nextFlag = true;
      // this.rightcountDeg = 0;
      let res = await nextImage({
        id:
          this.msgId.substring(0, 1) === "A"
            ? this.msgId.substring(1)
            : this.msgId
      });
      if (res.code === 0) {
        this.nextFlag = false;
        if (!res.data) {
          this.$message.warning("已是最后一张");
          return;
        } else {
          this.rightcountDeg = 0;
        }
        this.msgId = res.data.id;
        if (res.data.customName) {
          this.localBodyName = res.data.customName;
        } else {
          this.localBodyName = res.data.localBody.split("/")[1];
        }
        // 有旋转角度的
        if (res.data.localBody.indexOf("/rotate,") != -1) {
          this.rightcountDeg = Number(res.data.localBody.split("/rotate,")[1]);
        }
        this.previewPicturesUrl = res.data.localBody.split(
          "?x-oss-process=image"
        )[0];
        this.localBody = res.data.localBody;
      }
    },
    async getInitData(tabIndex = "") {
      let arr = []; 
      if (this.IMInfo.status === 1) {
        arr.push(
          {
            id: 4,
            name: "问卷选择",
            icon: require("../../static/IMInput/inquery.png")
          },
          {
            id: 5,
            name: "推荐服务",
            icon: require("../../static/IMInput/service@3x.png")
          },
          {
            id: 6,
            name: "病历夹",
            icon: require("../../static/IMInput/dossier@3x.png")
          }
        );
      } else {
        arr.push(
          {
            id: 4,
            name: "问卷选择",
            icon: require("../../static/IMInput/inquery.png")
          },
          {
            id: 3,
            name: "续约当前",
            icon: require("../../static/IMInput/treaty.png")
          },
          {
            id: 5,
            name: "推荐服务",
            icon: require("../../static/IMInput/service@3x.png")
          },
          {
            id: 6,
            name: "病历夹",
            icon: require("../../static/IMInput/dossier@3x.png")
          } 
        ); 
      }
      if(this.$store.state.userPlatForm === "platForm"&&this.routerName != "consultRoom"){
          arr.push(
            {
              id: 7,
              name: "推荐落地页",
              icon: require("../../static/IMInput/land-page.png")
            }
          )
      } 
      this.morePopoverList =
        this.activeName == "third" || this.activeName == "four"
          ? []
          : [...this.popoverList, ...arr];
    },
    childByValue(e) {
      if (e == 1) {
        this.isMiniRoom = false;
        this.getMiniList();
      }
    },
    async getMiniRoomId(id) {
      let res = await api_getintoInquiryRoom({
        inquiryId: id
      });
      if (res.code == 0) {
        this.conversationID = res.data.groupCode;
        this.$socket.emit("setGroupCode", res.data.groupCode, data => {});
        this.$store.commit("GROUP_CODE", res.data.groupCode);
        this.roomcodeId = res.data.id;
        if (this.currentTab == 1) {
          if (this.serviceCode == 3) {
            this.isEndConsultation = true;
          } else {
            this.isEndConsultation = false;
          }
        } else {
          this.isEndConsultation = false;
        }

        this.initData();
      } else {
        this.$message.error(res.message);
      }
    },
    //=============================================================================================================================
    // 专项房间列表点击会话接收子组件传来的数据
    enterMessage(a, b, c, d, e) {
      this.flagMessage = true;
      this.conversationID = a;
      this.$store.commit("GROUP_CODE", a);
      this.serviceCode = b;
      this.roomcodeId = c;
      // 问卷id ---lxs
      this.inquiryId = c;
      this.setIntervalReady();
      this.inquiryStatus = d;

      this.textMsg = "";
      this.disableMsgInput = e;

      if (this.currentTab == 1) {
        if (this.serviceCode == 3) {
          this.isEndConsultation = true;
        } else {
          this.isEndConsultation = false;
        }
      } else {
        this.isEndConsultation = false;
      }
      setTimeout(() => {
        this.isMiniRoom = false;
        this.initData();
      }, 1000);
    },
    //=============================================================================================================================
    // 协同会话房间
    childToRoom(code, isHistory, synergyId) {
      this.activeName = "four";
      this.historyCurrent = 1;
      this.total = 0;
      this.bizUnionId = synergyId;
      console.log("协同会话历史会话或者进入房间获取参数", code, isHistory);
      this.isCooperateIM = false;
      this.synergyRoomCode = code;
      if (isHistory) {
        this.disableMsgInput = true;
      } else {
        this.disableMsgInput = false;
      }
      this.getSynergyDetails();
      this.$socket.emit("setGroupCode", code, data => {});
      this.setIntervalReady();
      this.recordContent = [];
      setTimeout(() => {
        this.initData();
      }, 1000);
    },
    // 获取会诊详情
    async getSynergyDetails() {
      let res = await synergyDetails(this.bizUnionId);
      if (res.code == 0) {
        //进行中的视频问诊
        if (this.onlineNumTimer) {
          clearInterval(this.onlineNumTimer);
        }
        if (res.data.type == "video" && res.data.status == "underway") {
          this.isJoinVideoRoom = true;
          this.startTimer();
        }
      }
    },

    // 初始化数据
    initData() {
      this.recallData = {};
      this.getMeassageLists();
      this.scrollToBottom();
    },
    // 获取医护对话的初始化数据
    docInitData() {
      this.recallData = {};
      this.getMeassageDocLists();
      this.scrollToBottom();
    },
    // 获取已读的序号
    getReadySe() {
      clearInterval(this.SetIntervalRes);
      this.SetIntervalRes = setInterval(() => {
        if (this.activeName === "third") {
          // 请求医护对话已读接口
          this.setIntervalDocReady();
        } else {
          this.setIntervalReady();
        }
      }, 10000);
    },
    // 请求已读接口
    async setIntervalReady() {
      if (this.conversationID) {
        let res = await getReadySequence({
          groupCode:
            this.activeName == "four"
              ? this.synergyRoomCode
              : this.conversationID
        });
        if (res.code == 0) {
          this.sequence = res.data;
        }
      }
    },
    // 请求医护对话已读接口
    async setIntervalDocReady() {
      if (this.conversationID) {
        let res = await getReadyDocSequence({
          groupCode: this.conversationID
        });
        if (res.code == 0) {
          this.sequence = res.data.doctor;
        }
      }
    },
    //创建小房间
    createRoomBtn() {
      // 关闭新增按钮
      this.isMiniRoomEdit = !this.isMiniRoomEdit;
    },
    // 搜索小房间列表
    async getMiniList() {
      let res = await api_getInquiryList({ wholeCourseId: this.wholeCourseId });
      if (res.code == 0) {
        if (res.data.length == 0) {
          this.isMiniRoom = false;
        } else {
          let arr = res.data;
          let id = "";
          for (let item of arr) {
            if (item.inquiryStatus < 4) {
              this.isMiniRoom = false;
              id = item.id;
              if (id) {
                this.getMiniRoomId(id);
              }
              return;
            } else {
              this.isMiniRoom = false;
            }
          }
        }
      }
    },

    handleTabClick(tab) {
      this.currentTab = tab.index;
      this.visibleMorePop = false;
      this.visibleOverPop = false;
      this.unLock();
      this.wholeCourseId = this.IMInfo.id || this.IMInfo.wholeCourseId;
      this.historyCurrent = 1;
      this.total = 0;
      if (tab.index == 0) {
        this.disableMsgInput = false;
        this.conversationID = this.IMInfo.imId?.slice(5);
        this.$store.commit("GROUP_CODE", this.IMInfo.imId?.slice(5));
        this.$socket.emit("setGroupCode", this.conversationID, data => {});
        this.setIntervalReady();
        this.initData();
      }
      // 专项会话房间
      if (tab.index == 1) {
        this.isMiniRoom = true;
        this.disableMsgInput = true;
        this.wholeCourseId = this.IMInfo.id || this.IMInfo.wholeCourseId;
        let groupCode = this.IMInfo.imId;
        if (this.IMInfo.imId) {
          groupCode = this.IMInfo.imId.slice(5);
        }
        this.$socket.emit("setGroupCode", groupCode, data => {});
      } else {
        this.isMiniRoom = false;
      }
      if (tab.index == 2) {
        this.disableMsgInput = false;
        this.conversationID = this.IMInfo.caseGroupRoomId?.slice(5);
        if (!this.conversationID) {
          this.$message.error(
            "当前患者还未被医生接收，请接收后再联系医护团队~"
          );
          return;
        } else {
          this.$socket.emit("setGroupCode", this.conversationID, data => {});
        }
        this.$store.commit("GROUP_CODE", this.IMInfo.caseGroupRoomId?.slice(5));
        this.setIntervalDocReady(); // 调用已读接口
        this.docInitData(); // 初始化数据
      }
      //协同会话
      if (tab.index == 3) {
        this.isCooperateIM = true;
      } else {
        this.isCooperateIM = false;
      }
      this.getInitData(tab.index);
      clearInterval(this.onlineNumTimer);
    },
    toCooperateRoom() {
      this.getInitData(3);
    },
    getList() {},
    // 滚动到底部
    scrollToBottom() {
      if (this.$refs["vs"]) {
        this.$nextTick(() => {
          setTimeout(() => {
            // 方式一：
            // this.$refs['vs'].scrollIntoView('#scrollBottom', 500)
            // 方式二：
            this.$refs["vs"].scrollTo({ y: 9999999 }, 500, "easeInQuad");
          }, 30);
        });
      }
    },
    // 回车和换行
    carriageReturn() {
      let e = window.event || arguments[0];
      // 英文下｜中文下： 13 Enter Enter
      // 中文下有文字没进入输入框情况是：299 Enter Enter
      if (e.key == "Enter" && e.code == "Enter" && e.keyCode == 13) {
        if ((e.ctrlKey && e.which == 13) || e.metaKey) {
          // e.ctrlKey && e.which == 13证明是ctrl+enter
          this.textMsg = this.textMsg + "\n";
        } else {
          e.returnValue = false;
          if (this.pageName == "case-4") {
            this.docSendText();
          } else {
            this.sendText();
          }
          return false;
        }
      }
    },
    // 发送文字消息
    sendText(type, text) {
      if (this.textMsg.match(/^[ ]*$/)) {
        this.textMsg = this.textMsg.replace(/\s+/g, "");
        this.$message("发送内容不允许为空");
        return false;
      }
      let textMsg = this.$setEditorText(this.textMsg);
      let content;
      if (this.currentTab == 1) {
        if (this.inquiryStatus == 1) {
          this.$message("问诊未开始！不能发消息");
          return;
        }
        if (this.serviceCode != 3) {
          this.$message("无法发送消息");
          return;
        }
      }
      // 如果是常用语句
      if (type == "overuse") {
        content = text;
      } else {
        if (!this.textMsg) {
          return;
        }
        content = textMsg;
      }
      if(this.loadSend){
        return
      }
      this.loadSend = true
      api_sendTimText({
        groupCode:
          this.activeName == "four"
            ? this.synergyRoomCode
            : this.conversationID,
        sendUserId: localStorage.getItem("userid"),
        msgBody: {
          text: content
        }
      })
        .then(imResponse => { 
          let newDate1 = new Date();
          this.newDate = moment(newDate1).format("YYYY-MM-DD HH:mm:ss");
          this.recordContent.push({
            type: "TIMTextElem",
            flow: "out",
            payload: {
              text: content
            }
          });
          this.recallData = {}; // 消息发送成功重置撤回消息内容
          this.scrollToBottom();
          this.textMsg = ""; 
          this.$refs.sendInput.blur();
          setTimeout(() => {
            this.loadSend = false
            // this.getRoomStatus();
          }, 1000);
        })
        .catch(imError => {
          // 发送失败
          this.loadSend = false
          this.$message.error(imError.message);
        });
    },
    // 医护上门客服发送文字消息
    async docSendText(type, text) {
      let content;
      if (this.currentTab == 1) {
        if (this.inquiryStatus == 1) {
          this.$message("问诊未开始！不能发消息");
          return;
        }
        if (this.serviceCode != 3) {
          this.$message("无法发送消息");
          return;
        }
      }
      // 如果是常用语句
      if (type == "overuse") {
        content = text;
      } else {
        if (!this.textMsg) {
          return;
        }
        content = this.textMsg;
      }
      let res = await api_sendDocter({
        text: content,
        groupCode: this.conversationID,
        nursingServiceImId: this.IMInfo.id
      });
      if (res.code === 0) {
        // 刷新左侧患者列表
        this.$emit("refreshPatientList");
      }
      this.recallData = {}; // 消息发送成功重置撤回消息内容
      this.textMsg = "";
    },
    // 获取问诊状态
    async getRoomStatus() {
      // let res = await apiIntoInquiryRoom({
      //   inquiryId: this.$store.state.conversationID,
      // })
      // this.$store.commit("INQUIRY_STATUS",res.data.inquiryStatus)
    },
    // 在自定义弹框中
    inModal(val) {
      if (this.$refs["vs"]) {
        this.$refs["vs"].mergedOptions.scrollPanel.scrollingY = !val;
        this.$refs["vs"].scrollYEnable = !val;
        // this.$forceUpdate()
      }
    },
    // 滚动触发事件
    handleScroll(vertical, horizontal, nativeEvent) {
      if (!vertical.scrollTop) {
        this.noData = true;
        setTimeout(() => {
          this.noData = false;
          this.$refs["vs"].scrollTo({ y: 5 }, 500, "easeInQuad");
        }, 1000);
        if (
          this.historySize * this.historyCurrent >= this.total ||
          this.noLoad
        ) {
          return;
        }
        this.historyCurrent++;
        if (this.activeName == "third") {
          // 医护对话
          this.getMeassageDocLists(true);
        } else {
          this.getMeassageLists(true);
        }
      }
    },
    handleComplete(v, e) {},
    // 内容尺寸发生变化
    handleResize(v, h, e) {},
    //历史聊天消息列表
    async getMeassageLists(isTurnPage) {
      //isTurnPage为true ：页面滚动加载聊天记录
      // 打开某个会话时，第一次拉取消息列表
      if (!this.conversationID && this.activeName != "four") {
        //未查到那种情况下不存在ID
        return;
      }
      this.noLoad = true;
      let res = await apiGgetRecordByRoomCode({
        groupCode:
          this.activeName == "four"
            ? this.synergyRoomCode
            : this.conversationID,
        size: this.historySize,
        current: this.historyCurrent
      }).catch(err => {
        this.noLoad = false;
        if (!isTurnPage) {
          this.recordContent = [];
          this.total = 0;
        }
      });
      this.noLoad = false;
      let list = this.mapList(res.data.records);
      this.total = res.data ? res.data.total : 0;
      if (isTurnPage) {
        var oldList = this.recordContent;
        oldList = [...list, ...oldList];
        this.recordContent = oldList;
      } else {
        this.recordContent = list;
      }
      // this.setIntervalReady()
    },
    // 初始化医生列表的数据
    async getMeassageDocLists(isTurnPage) {
      // 接口换成医护对话的接口
      this.conversationID = this.IMInfo.caseGroupRoomId?.slice(5);
      this.$store.commit("GROUP_CODE", this.IMInfo.caseGroupRoomId?.slice(5));
      this.$store.commit("PATIENT_ID", this.IMInfo.patientId);
      this.noLoad = true;
      let res = await apiGgetRecordByRoomCode({
        groupCode: this.conversationID,
        size: this.historySize,
        current: this.historyCurrent
      }).catch(err => {
        this.noLoad = false;
      });
      this.noLoad = false;
      let list = this.mapList(res.data.records);
      this.total = res.data ? res.data.total : 0;
      if (isTurnPage) {
        var oldList = this.recordContent;
        oldList = [...list, ...oldList];
        this.recordContent = oldList;
      } else {
        this.recordContent = list;
      }
    },
    startTimer() {
      if(!this.bizUnionId){
        return
      }
      this.onlineNumTimer = setInterval(() => {
        this.getOnlineCount();
      }, 10000);
    },
    //map转化
    mapList(arr, isSocket) {
      let list = arr.map(item => {
        let json = {};
        json.groupCode = item.groupCode;
        json.historyMsg = "historyMsg";
        json.createTime = item.createTime;
        json.customName = item.customName;
        // json.mineMsg = item.fromAccount == localStorage.getItem('userid') ? 'mine' : ''  // 暂时用不上
        json.from = item.fromAccount;
        // 客服消息管理
        if (this.pageName == "case-4") {
          json.nick =
            item.userType == "3" || !item.userName
              ? "疗程管理师"
              : this.chatPatientName;
        } else if (this.routerName == "consultRoom") {
          json.nick =
            item.userType == "3" || item.userType == "4"
              ? "客服佳佳"
              : item.userName;
        } else {
          json.nick =
            item.userType == "3" || !item.userName
              ? "疗程管理师"
              : item.userName;
        }
        json.localBody = item.localBody;
        json.title = item.title;
        let itemCon = JSON.parse(item.msgBody)[0].MsgContent;
        let sendId = "";
        if (itemCon.Ext == 2000) {
          sendId = JSON.parse(itemCon.Data).send_user_id;
        }
        //out 自己发右边
        json.flow =
          item.fromAccount.indexOf(localStorage.getItem("userid")) > -1
            ? "out"
            : "in";
        if (sendId == localStorage.getItem("userid")) {
          json.flow = "out";
        }
        json.id = "A" + item.id;
        json.sequence = item.msgSeq;
        // isPlaceMsg为1时已撤回文本消息
        json.isPlaceMsg = item.isPlaceMsg;
        if (!item.userUrl) {
          json.avatar = this.imgHead;
        } else {
          let dotUrl = item.userUrl.indexOf("http");
          if (dotUrl == -1) {
            json.avatar = this.doctorImg + item.userUrl;
          } else {
            json.avatar = item.userUrl;
          }
        }
        json.msgSeq = item.msgSeq;
        let messCon = JSON.parse(item.msgBody);
        // socket中监听视频会话人数
        if (isSocket) {
          if (messCon[0].MsgContent.Ext == 2009 && !this.onlineNumTimer) {
            this.startTimer();
          }
        }
        json.type = messCon[0].MsgType;
        if (json.type == "TIMTextElem") {
          json.payload = {
            text: messCon[0].MsgContent.Text
          };
        } else if (json.type == "TIMCustomElem") {
          json.payload = {
            data:
              messCon[0].MsgContent.Ext == 2001
                ? messCon[0].MsgContent.Data
                : messCon[0].MsgContent.Data,
            description: messCon[0].MsgContent.Desc,
            extension: messCon[0].MsgContent.Ext || ""
          };
        } else if (json.type == "TIMImageElem") {
          json.payload = {
            imageInfoArray: messCon[0].MsgContent.ImageInfoArray,
            localBody: item.localBody
          };
        } else if (json.type == "TIMVideoFileElem") {
          json.payload = {
            data: item.localBody,
            // description: messCon[0].MsgContent.Desc,
            extension: 2001
          };
        } else if (json.type == "TIMSoundElem") {
          json.payload = item.localBody;
          json.payload = {
            url: item.localBody,
            second: messCon[0].MsgContent.Second
          };
        } else if (json.type == "TIMFileElem") {
          json.payload = {
            data: this.doctorImg + item.localBody,
            fileName: messCon[0].MsgContent.FileName
          };
        }
        return json;
      });
      return list;
    },
    // 发送表情
    addEmoji(em) {
      this.textMsg += em.alt;
    },
    //替换表情符号为图片
    replaceEmoji(str) {
      let replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, (item, index) => {
        for (let i = 0; i < this.emojiList.length; i++) {
          let row = this.emojiList[i];
          if (row.alt == item) {
            let onlinePath = this.doctorImg + "face/" + row.url;
            let imgstr =
              '<img style="width:25px;height: 25px" src="' + onlinePath + '">';
            return imgstr;
          }
        }
      });
      return replacedStr;
    },
    // 显示隐藏更多卡片
    closeMorePopver() {
      this.visibleOverPop = false;
      this.visibleMorePop = !this.visibleMorePop;
      if (this.visibleMorePop) {
        this.sendInput();
      } else {
        this.unlockRoom();
      }
      if (this.visibleMorePop) {
        this.getCustomerService();
      }
    },
    // 显示隐藏常用语句卡片
    closeOverPopver() {
      this.visibleMorePop = false;
      this.visibleOverPop = !this.visibleOverPop;
      if (this.visibleOverPop) {
        this.sendInput();
      } else {
        this.unlockRoom();
      }
      // 打开后就获取常用语句
      if (this.visibleOverPop) {
        this.getAllOveroutList();
      }
    },
    // 选中事件
    openMore(data) {
      switch (data) {
        case 0:
          this.sendFile();
          break;
        case 1:
          // 在线教程
          this.defaultIdType = "hospitalId";
          this.sendOnLineTutorial();
          break;
        case 2:
          // 宣传患教
          this.defaultIdType = "hospitalId";
          this.sendPropaganda();
          break;
        case 3:
          // 续约提醒
          this.sendContinueTreaty();
          break;
        case 4:
          // 问卷选择
          this.defaultIdType = "hospitalId";
          this.questionSelect();
          break;
        case 5:
          // 推荐服务
          // this.defaultIdType = "hospitalId";
          this.serviceRecommonSelect();
          break;
        case 6:
          // 病历夹
          this.dossierSelect();
          break;
        case 7:
          // 落地页
          this.landPageSelectClick();
          break;
        case 8:
          // 弹框
          this.patFeedbackAssQue();
          break;
        case 9:
          break;
        default:
          this.questionTypeId = data;
          this.sendQuestionnaire();
          break;
      }
    },
    //判断房间类型
    async getCustomerService() {
      let res = await getCustomerService(this.conversationID);
      if (res.code == 0) {
        this.newHospitalId = res.data;
      }
    },

    // 发送文件
    sendFile() {},
    // 判断是否是图片
    isImageType(str) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
          "HEIC",
          "MOV"
        ].indexOf(str.toLowerCase()) !== -1
      );
    },

    // 上传文件的方法
    uploadFile(e) {
      if (this.currentTab == 1) {
        if (this.inquiryStatus == 1) {
          this.$message("问诊未开始");
          return;
        }
        if (this.serviceCode != 3) {
          this.$message("无法发送消息");
          return;
        }
      }
      const rule = /\.(swf|avi|flv|mpg|rm|mov|asf|3gp|mkv|rmvb|mp4|m4v)$/;

      const files = e.target.files;

      this.visibleMorePop = false;
      let fileType = e.target.files[0].name;
      let fileIndex = fileType.lastIndexOf(".");
      let fileStr = fileType.substr(fileIndex + 1);
      let isImage = this.isImageType(fileStr);
      if (isImage) {
        if (files && files[0].name.match(rule) != null) {
          var url = URL.createObjectURL(files[0]);

          // var videos =document.getElementById("audio_id")
          // videos.src = url;

          var audioElement = new Audio(url);

          audioElement.addEventListener("loadedmetadata", _event => {
            let duration = audioElement.duration;
            if (duration / 60 > 10) {
              this.$message.info("视频最多10分钟");
              return false;
            }
            let param = new FormData();
            param.append("file", files[0], files[0].name);
            param.append("path", "dsicm-doctor");

            axios
              .post("/dsicm-contact-platform/feign/file/upload", param)
              .then(res => {
                if (res.data.success) {
                  sendTimMessage({
                    dataMessage: res.data.data,
                    fromAccount: this.fromId,
                    groupCode: this.conversationID,
                    timMessageType: "TIMCustomElem",
                    timCustomType: 2001
                  }).then(res => {});
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch(err => {
                this.$message.error("上传失败");
              });
          });
        } else {
          // 图片
          let param = new FormData();
          param.append("file", files[0], files[0].name);
          param.append("path", "tim-image");
          axios
            .post("/dsicm-contact-platform/feign/file/upload", param)
            .then(res => {
              if (res.data.success) {
                specialFileUpdate({
                  groupCode:
                    this.activeName == "four"
                      ? this.synergyRoomCode
                      : this.conversationID,
                  msgBody: {
                    data: res.data.data,
                    ext: "14"
                  },
                  sendUserId: localStorage.getItem("userid")
                }).then(ress => {
                  let newDate = new Date();
                  this.newDate = moment(newDate).format("YYYY-MM-DD HH:mm:ss");
                  this.recordContent.push({
                    type: "TIMCustomElem",
                    flow: "out",
                    payload: {
                      data: res.data.data,
                      extension: 14
                    }
                  });
                  this.scrollToBottom();
                });
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("上传失败");
            });
        }
      } else {
        if (files && files[0].name.match(rule) != null) {
          var url = URL.createObjectURL(files[0]);

          // var videos =document.getElementById("audio_id")
          // videos.src = url;
          var audioElement = new Audio(url);

          audioElement.addEventListener("loadedmetadata", _event => {
            let duration = audioElement.duration;
            if (duration / 60 > 10) {
              this.$message.info("视频最多10分钟");
              this.visibleMorePop = false;
              return false;
            }
            let param = new FormData();
            param.append("file", files[0], files[0].name);
            param.append("path", "tim-video");

            axios
              .post("/dsicm-contact-platform/feign/file/upload", param)
              .then(res => {
                if (res.data.success) {
                  specialFileUpdate({
                    groupCode:
                      this.activeName == "four"
                        ? this.synergyRoomCode
                        : this.conversationID,
                    msgBody: {
                      data: res.data.data,
                      ext: "2001"
                    },
                    sendUserId: localStorage.getItem("userid")
                  }).then(ress => {
                    this.visibleMorePop = false;
                  });
                } else {
                  this.visibleMorePop = false;
                  this.$message.error(res.data.message);
                }
              })
              .catch(err => {
                this.$message.error("上传失败");
                this.visibleMorePop = false;
              });
          });
        } else {
          const file = files[0];
          if (files && files[0]) {
            if (file.size > 1024 * 1024 * 200) {
              this.$message.info("最大可发送200M文件");
              this.visibleMorePop = false;
              return false;
            }
          }

          let typeList = ["doc", "xls", "pdf", "docx", "xlsx"];
          if (
            typeList.indexOf(
              file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase()
            ) < 0
          ) {
            this.visibleMorePop = false;
            return this.$message.info("该文件格式不支持上传");
          }
          let param = new FormData();
          param.append("file", file, file.name);
          param.append("path", "tim-file");
          axios
            .post("/dsicm-contact-platform/feign/file/upload", param)
            .then(res => {
              if (res.data.success) {
                specialFileUpdate({
                  groupCode:
                    this.activeName == "four"
                      ? this.synergyRoomCode
                      : this.conversationID,
                  msgBody: {
                    data: JSON.stringify({
                      path: res.data.data,
                      size: file.size / 1024
                    }),
                    ext: "20",
                    desc: file.name
                  },
                  sendUserId: localStorage.getItem("userid")
                }).then(ress => {
                  this.visibleMorePop = false;
                  this.recordContent.push({
                    type: "TIMCustomElem",
                    flow: "out",
                    payload: {
                      data: JSON.stringify(res.data.data),
                      extension: 20,
                      description: file.name
                    }
                  });
                  this.scrollToBottom();
                });
              } else {
                this.visibleMorePop = false;
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              this.visibleMorePop = false;
            });
        }
      }
    },
    // 在线教程
    sendOnLineTutorial() {
      this.onlineJia = true;
      this.sendLoding = false;
      this.keyWord = "";
      this.onlineJiaCurrent = 1;
      this.courseSize = 10;
      this.trainChapter();
      this.visibleMorePop = false;
    },
    // 宣传教育
    sendPropaganda() {
      this.promoting = true;
      this.sendLoding = false;
      this.promotingCurrent = 1;
      this.promotingSize = 10;
      this.contentSearch = "";
      this.getMission();
      this.visibleMorePop = false;
    },
    // 续约提醒
    async sendContinueTreaty() {
      let res = await reportOrderPush({
        groupCode: this.conversationID,
        patientId: this.IMInfo.patientId,
        skipCheck: false
      });
      if (res.code === 0) {
        this.visibleMorePop = false;
      } else {
        this.$message.error(res.message);
        this.visibleMorePop = false;
      }
    },
    // 问卷
    sendQuestionnaire() {
      this.questionpaper = true;
      this.getSurveyOss("问题问卷");

      this.visibleMorePop = false;
    },
    // 量表
    sendGauge() {
      if (this.currentTab == 0) {
        this.$message("当前会话不能发送");
        return;
      }
      this.assessment = true;
      //  this.assessmentScale()
      this.getSurveyOss("评估量表");
      this.visibleMorePop = false;
    },

    // 随访记录
    sendFollow() {
      if (this.currentTab == 0) {
        this.$message("当前会话不能发送");
        return;
      }
      this.questionpaperone = true;
      // this.questRecord()
      this.getSurveyOss("随访记录");
      this.visibleMorePop = false;
    },
    questionSelect() {
      Object.assign(this.questionCom, {
        ...this.questionCom,
        visible: true,
        title: "问卷选择"
      });
      // 获取表格数据
      this.visibleMorePop = false;
    },
    // 推荐服务
    serviceRecommonSelect() {
      Object.assign(this.serviceRecommon, {
        ...this.serviceRecommon,
        visible: true,
        title: "推荐服务"
      });
      // 获取表格数据
      this.visibleMorePop = false;
    },
     // 选择落地页
    landPageSelectClick() {
      this.landPageObj.visible = true 
      this.visibleMorePop = false;
    },
    // 病历夹
    dossierSelect() {
      this.dossier.visible = true;
    },
    // 关闭病历夹
    dossierHandleClose() {
      this.dossier.visible = false;
      this.$refs["dossierRuleForm"].resetFields();
    },
    // 发送病历夹
    patientCasePush(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let { code, data, message } = await patientCaseHistoryPush({
            content: this.dossier.content,
            groupCode: this.conversationID,
            patientId: this.IMInfo.patientId,
            skipCheck: true,
            title: this.dossier.title,
            wholeCourseId: this.$store.state.serviceItem.wholeCourseId || this.$store.state.wholeCourseId,
            customerService: this.routerName == "consultRoom" ? true : false
          });
          if (code === 0) {
            this.$message.success("病历夹推送成功");
            this.$refs["dossierRuleForm"].resetFields();
            this.dossier.visible = false;
            this.visibleMorePop = false;
          } else {
            this.$message.error(message);
          }
        } else {
          return false;
        }
      });
    },
    // 重置病历夹
    dossierReset(formName) {
      // this.$refs[formName].resetFields();
      this.dossier.title = "";
      this.dossier.content = "";
    },
    // 患者反馈评估问卷
    patFeedbackAssQue() {
      if (this.currentTab == 0) {
        this.$message("当前会话不能发送");
        return;
      }
      // 远程的数据
      // this.loadAll()
      Object.assign(this.patFeedbackAssQues, {
        ...this.patFeedbackAssQues,
        visible: true,
        title: "患者反馈评估问卷",
        tabListConfig: patfeedbackColumn
      });
      // 获取表格数据
      this.visibleMorePop = false;
    },
    // 接收添加的问卷
    receiveQuestion(data) {
      this.form.renewQuestionnaireId = data.id;
      this.form.renewQuestionnaireName = data.title;
    },
    //在线教程分页触发事件
    onlineJiaPageSize(val) {
      this.courseSize = val;
      this.onlineJiaCurrent = 1;
      this.trainChapter();
    },
    onSearch() {
      this.onlineJiaCurrent = 1;
      this.trainChapter();
    },
    //在线教程分页触发事件
    onlineJiaCurrentChange(val) {
      this.onlineJiaCurrent = val;
      this.trainChapter();
    },
    handleLookArticle(row) {
      this.drawer = true;
      this.currentId = row.id;
    },
    //宣传患教分页触发事件
    promotingPageSize(val) {
      this.promotingSize = val;
      this.promotingCurrent = 1;
      this.getMission();
    },
    promotingCurrentChange(val) {
      this.promotingCurrent = val;
      this.getMission();
    },
    //获取在线教程目录接口
    async trainChapter() {
      let res = await getChapter({
        current: this.onlineJiaCurrent,
        tagId: 7,
        size: this.courseSize,
        available: 1,
        keyWord: this.keyWord,
        userState: this.$store.state.userPlatForm === "platForm" ? 2 : 1, //1机构 2平台
        companyId: this.$store.state.companyId, //平台
        hospitalId: this.newHospitalId, //机构
        isLaunched: "1"
        // [this.defaultIdType]:
        //   this.defaultIdType === "hospitalId"
        //     ? this.newHospitalId
        //     : this.$store.state.companyId
      });
      this.onlineJiaTable = res.data.records;
      this.onlineJiaTotal = res.data.total;
    },
    //获取宣传患教列表接口
    async getMission() {
      let res = await getMissionData({
        current: this.promotingCurrent,
        available: 1,
        size: this.promotingSize,
        title: this.contentSearch,
        userState: this.$store.state.userPlatForm === "platForm" ? 2 : 1, //1机构 2平台
        companyId: this.$store.state.companyId, //平台
        hospitalId: this.newHospitalId, //机构
        deleted: 0
        // [this.defaultIdType]:  this.defaultIdType === "hospitalId"  ? this.newHospitalId: this.$store.state.companyId
      });
      this.promotingTable = res.data.records;
      this.promotingTotal = res.data.total;
    },

    //宣传患教发送问卷按钮
    async promotingSend(index, row) {
      if (this.currentTab == 1 && this.inquiryStatus == 1) {
        this.$message("问诊未开始");
        return;
      }
      if (this.currentTab == 1 && this.serviceCode != 3) {
        this.$message("无法发送消息");
        return;
      }
      if (this.multiSendList.length < 1) {
        this.$message.warning("当前暂无可发送内容");
        return;
      }
      let end = [];
      this.multiSendList.map(item => {
        end.push({
          fromId: this.fromId, //个案IM账号,
          groupCode: this.conversationID,
          missionId: item.id, //ids
          wholeCourseId: this.wholeCourseId,
          patientId: this.$store.state.patientId
        });
      });
      this.sendLoding = true;
      let res = await mission_push_batch(end);
      if (res.code == 0) {
        this.$message({
          message: "推送宣教成功",
          type: "success"
        });
        this.promoting = false;
        this.sendLoding = false;
      } else {
        this.sendLoding = false;
        this.$message.error(res.message);
      }
    },
    //问题问卷列表数据接口
    async getSurveyOss(name) {
      if (name === "问题问卷") {
        let res = await queryList({
          examTypeId: this.questionTypeId,
          draft: false,
          current: this.questionCurrent,
          size: this.questionPage
        });
        if (res.code == 0) {
          let data = res.data;
          this.questionTable = data.records;
          this.assessmentTable = data.records;
          this.tableData = data.records;
          this.qusetionTotal = data.total;
        }
      } else {
        let res = await getMissonList({
          tagName: name
        });
        if (res.code == 0) {
          let data = res.data;
          this.questionTable = data.records;
          this.assessmentTable = data.records;
          this.tableData = data.records;
          this.qusetionTotal = data.total;
        }
      }
    },

    //问题问卷发送问卷按钮
    async questionSend(index, row) {
      if (this.currentTab == 1) {
        if (this.inquiryStatus == 1) {
          this.$message("问诊未开始");
          return;
        }
        if (this.serviceCode != 3) {
          this.$message("无法发送消息");
          return;
        }
      }
      // let res = await api_post_push_survey({
      //   fromId: this.fromId,
      //   groupCode: this.conversationID,
      //   patientId: this.IMInfo.patientId,
      //   questionnaireName: row.name,
      //   surveyId: row.id,
      //   tagName: row.tagName,
      //   wholeCourseId: this.wholeCourseId,
      // })
      // if (res.code == 0) {
      //   this.$message({
      //     message: '推送问卷成功',
      //     type: 'success',
      //   })
      //   this.questionpaper = false
      // } else {
      //   this.$message.error(res.message)
      // }
      let patientIds = this.IMInfo.patientId;
      let params;
      if (this.currentTab == 0) {
        params = {
          examId: row.id,
          groupCode: this.conversationID,
          patientId: patientIds,
          wholeCourseId: this.wholeCourseId,
          fromId: this.fromId,
          questionnaireName: row.name,
          tagName: row.examTypeName
        };
      } else {
        params = {
          examId: row.id,
          groupCode: this.conversationID,
          patientId: patientIds,
          wholeCourseId: this.wholeCourseId,
          fromId: this.fromId,
          questionnaireName: row.name,
          inquiryId: this.inquiryId,
          tagName: row.examTypeName
        };
      }
      let res = await pushExamPaperSingle(params);
      if (res.code == 0) {
        let data = res.data;
        this.$message({
          message: "推送问题问卷成功",
          type: "success"
        });
        this.questionpaper = false;
      } else {
        this.$message.error(res.message);
      }
    },
    //问题问卷分页触发事件
    questionPageSize(val) {
      this.questionCurrent = val;
      this.getSurveyOss("问题问卷");
    },
    //问题问卷分页触发事件
    questionCurrentChange(val) {
      this.questionCurrent = val;
      this.getSurveyOss("问题问卷");
    },

    //评估量表列表数据接口
    //评估量表分页触发事件
    assessmentPageSize(val) {},
    assessmentCurrentChange(val) {},
    // 获取详情
    async getPageDetail() {
      let res = await questionnaireDetails({
        id: this.patFeedbackAssQues.paperId
      });
      if (res.code === 0) {
        this.patFeedbackAssQues.typeFormData = res.data;
      }
    },
    //评估量表发送
    async assessmentSend(index, row) {
      if (this.currentTab == 1) {
        if (this.inquiryStatus == 1) {
          this.$message("问诊未开始");
          return;
        }
        if (this.serviceCode != 3) {
          this.$message("无法发送消息");
          return;
        }
      }
      let patientIds = this.IMInfo.patientId;
      let params;

      if (this.currentTab == 0) {
        params = {
          examId: row.id,
          groupCode: this.conversationID,
          patientId: patientIds,
          wholeCourseId: this.wholeCourseId,
          fromId: this.fromId,
          questionnaireName: row.description,
          tagName: "评估量表"
        };
      } else {
        params = {
          examId: row.id,
          groupCode: this.conversationID,
          patientId: patientIds,
          wholeCourseId: this.wholeCourseId,
          fromId: this.fromId,
          questionnaireName: row.description,
          inquiryId: this.inquiryId,
          tagName: "评估量表"
        };
      }
      let res = await pushMissionIMNew(params);
      if (res.code == 0) {
        let data = res.data;
        this.$message({
          message: "推送量表成功",
          type: "success"
        });
        this.assessment = false;
      } else {
        this.$message.error(res.message);
      }
    },
    //发送在线教程（多选）
    async onlineCourseSend() {
      if (this.currentTab == 1 && this.inquiryStatus == 1) {
        this.$message("问诊未开始");
        return;
      }
      if (this.currentTab == 1 && this.serviceCode != 3) {
        this.$message("无法发送消息");
        return;
      }
      if (this.multiSendList.length < 1) {
        this.$message.warning("当前暂无可发送内容");
        return;
      }
      let end = [];
      this.multiSendList.map(item => {
        end.push({
          chapterId: item.id,
          fromId: this.fromId,
          groupCode: this.conversationID,
          wholeCourseId: this.wholeCourseId,
          patientId: this.$store.state.patientId
        });
      });
      this.sendLoding = true;
      let res = await chapter_push_batch(end);
      if (res.code == 0) {
        this.$message({
          message: "推送教程成功",
          type: "success"
        });
        this.onlineJia = false;
        this.sendLoding = false;
      } else {
        this.sendLoding = false;
        this.$message.error(res.message);
      }
    },
    /**
     * @description: 随访记录填报 或者发送
     * @param {*}
     * @return {*}
     */
    hometHandel(scope, type) {
      const userInfo = JSON.parse(localStorage.getItem("USERINFO"));
      const params = {
        answerer: type == 1 ? 3 : 1, //回答人 1-患者 2-医生 3-个案
        userId: localStorage.getItem("userid"), //当前登录admin的用户id
        ...userInfo,
        questionnaireId: scope.row.id, //问卷id
        questionnaireName: scope.row.name, //问卷名称
        tagName: scope.row.tagName
      };

      if (type == 1) {
        this.innerDrawer = true;
        this.iframUrl = `${process.env.VUE_APP_H5_URL}${params.questionnaireId}/${params.patientId}/demo`;
      }
      /**
       * @description: 调用发送接口，消息为后端推送，前端无需做处理
       * @param {*} type == 2
       * @return {*}
       */
      if (type == 2) {
        if (this.currentTab == 1) {
          if (this.inquiryStatus == 1) {
            this.$message("问诊未开始");
            return;
          }
          if (this.serviceCode != 3) {
            this.$message("无法发送消息");
            return;
          }
        }

        let patientIds = this.IMInfo.patientId;
        let params;

        if (this.currentTab == 0) {
          params = {
            examId: scope.row.id,
            groupCode: this.conversationID,
            patientId: patientIds,
            wholeCourseId: this.wholeCourseId,
            fromId: this.fromId,
            questionnaireName: scope.row.name,
            tagName: "随访记录"
          };
        } else {
          params = {
            examId: scope.row.id,
            groupCode: this.conversationID,
            patientId: patientIds,
            wholeCourseId: this.wholeCourseId,
            fromId: this.fromId,
            questionnaireName: scope.row.name,
            inquiryId: this.inquiryId,
            tagName: "随访记录"
          };
        }
        pushMissionIMNew(params).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.$message({
              message: "推送随访记录成功",
              type: "success"
            });
            this.questionpaperone = false;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    //点击患者历史图片放大
    enlargePicture(itemc, id, customName) {
      this.rightcountDeg = 0;
      if (itemc.localBody.split(",")[1]) {
        this.rightcountDeg = Number(itemc.localBody.split(",")[1]);
      }
      this.editPicStatus = false;
      this.msgId = id;
      if (customName) {
        this.localBodyName = customName;
      } else {
        this.localBodyName = itemc.localBody.split("/")[1];
      }
      this.localBody = JSON.parse(JSON.stringify(itemc.localBody));
      this.previewPicturesUrl = this.localBody.split("?x-oss-process=image")[0];
      this.previewPictures = true;
      this.zoomIndex = 10;
    },
    // 打开医生端图片
    openDoctorImage(item) {
      this.previewDoctorUrl = process.env.VUE_APP_OSS_URL + item;
      this.previewPicturesDoctor = true;
    },
    //点击医生历史图片放大
    bigPicture(item) {
      this.previewDoctorUrl = process.env.VUE_APP_OSS_URL + item;
      this.previewPicturesDoctor = true;
    },
    //点击个案历史图片放大
    bigIndividualImg(item) {
      this.bigIndividualUrl = item;
      this.bigIndividualDialog = true;
    },
    // 对照录入
    async moveReference(imgurl) {
      let filePath;
      if (this.localBody.indexOf("/rotate,") != -1) {
        filePath = this.localBody.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath =
          this.localBody + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      let res = await api_post_addTofoles({
        filePath: filePath,
        // wholeCourseId: local.get('allID'),
        wholeCourseId: this.$store.state.serviceItem.wholeCourseId,
        fileName: this.localBodyName,
        groupCode: this.conversationID
      });
      if (res.code == 0) {
        this.$message({
          message: "已添加到对照录入",
          type: "success"
        });
        // this.previewPictures = false;
      } else {
        this.$message.error("添加失败");
      }
    },
    // 结束在线随访问诊
    endConsultation() {
      this.$confirm("是否结束咨询?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "message-confirm-style"
      })
        .then(() => {
          sendDelayEnd({
            inquiryId: this.roomcodeId
          }).then(res => {
            if (res.code == 0) {
              this.$message.success("已结束咨询");
              this.visibleMorePop = false;
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
          this.visibleMorePop = false;
        });
    },
    // 常用语句发送
    sendOveruse(data) {
      this.isUpdateSentenceId = "";
      this.textMsg = data.content;
      // this.sendText('overuse', data.content)
      this.visibleOverPop = false;
    },
    //按下回车键触发
    onSubmit() {
      if (this.pageName == "case-4") {
        this.docSendText();
      } else {
        this.sendText();
      }
    },
    // 获取所有常用语句
    getAllOveroutList() {
      getOveroutList({ content: "" })
        .then(res => {
          if (res.code == 0) {
            this.overusePopoverList = res.data;
            this.overusePopoverListArr = JSON.parse(JSON.stringify(res.data));
          }
        })
        .catch(err => {});
    },
    // 获取常用语句
    changeOveroutInput(data) {
      getOveroutList({ content: data })
        .then(res => {
          if (res.code == 0) {
            this.overusePopoverList = res.data;
            data = "";
          }
        })
        .catch(err => {});
    },

    // 新增常用语句
    addSentence() {
      this.isSaveSentence = true;
      this.getAllOveroutList();
    },
    cancelAddSave() {
      this.isSaveSentence = false;
    },
    saveSentence(data) {
      if (!data) {
        this.$message("未输入");
        return;
      }
      for (let item of this.overusePopoverList) {
        if (item.content == data) {
          this.$message("常用语重复！");
          return;
        }
      }

      // 保存之前判断是否有重复
      addOverout({ content: data })
        .then(res => {
          if (res.code == 0) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.getAllOveroutList();
                this.isSaveSentence = false;
              }, 200);
            });
          }
        })
        .catch(err => {});
    },
    // 编辑常用语句
    updateSentence(data) {
      this.isUpdateSentenceId = data.id;
    },
    // 编辑后保存
    updateSaveSentence(data) {
      for (let item of this.overusePopoverListArr) {
        if (item.content == data.content) {
          this.$message("常用语重复！");
          return;
        }
      }
      updateOverout({ content: data.content, id: data.id })
        .then(res => {
          if (res.code == 0) {
            // 保存后恢复原样
            if (res.data) {
              this.isUpdateSentenceId = "";
              this.data = {};
              this.getAllOveroutList();
              this.$message.success("已添加");
            }
          }
        })
        .catch(err => {
          this.isUpdateSentenceId = "";
        });
    },
    // 删除常用语句
    deleteSentence(data) {
      let id = data.id;
      deleteOverout(id).then(res => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.visibleOverPop = false;
          this.unLock();
        }
      });
    },
    // 异常提醒关闭
    async signClose({ id, remind }, key) {
      let { code, data } = await patientAnomalyClose({ id, casesStatus: 2 });
      if (code == 0) {
        this.$message({
          type: "success",
          message: "患者异常提醒关闭成功"
        });
        this.$emit("getRightData", this.IMInfo);
      }
    }
  },
  // 清除定时器
  beforeDestroy() {
    clearInterval(this.SetIntervalRes);
    clearInterval(this.onlineNumTimer);
  }
};
</script>

<style lang="less">
.IM {
  .el-tabs {
    .el-tabs__header.is-top {
      .el-tabs__nav-wrap::after {
        height: 1px !important;
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.el-dialog {
  width: fit-content;
}
/deep/.el-dialog__body {
  padding-top: 0px;
}

.search-btns {
  margin-top: 5px;
}
.el-main {
  width: 100%;
  .main-content-list {
    height: 62vh;
    overflow: auto;
    padding: 15px;
    padding-top: 8px;
    background-color: #fff;
  }
}
.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}
.btn-bg {
  background: #1a7bfc;
  color: #fff;
}
/deep/.el-table td {
  padding: 6px 0;
}
.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  height: 600px;
  position: relative; /*定位*/
  // top: -20px;
  top: 0px;
  left: 0px;
  cursor: pointer;
}
.back-im {
  position: absolute;
  top: 0;
  right: 20px;
}
.viewer-pic {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  i {
    display: inline-block;
    padding: 8px;
    border-radius: 50%;
    background-color: #1a7bfc;
    color: #ffffff;
    margin-left: 20px;
    font-weight: 700;
    height: 30px;
    margin-top: 5px;
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 10px;
}

.health-search {
  display: flex;
}

.custom-34 {
  width: 540px;
  .info-content,
  .more-detail {
    .info-content-title {
      color: #333333;
      font-size: 15px;
      line-height: 25px;
      span {
        color: #1a7bfc;
      }
    }
    .info-content-flex {
      display: flex;
      align-items: center;
      color: #333333;
      background: rgba(61, 118, 246, 0.05);
      font-size: 14px;
      line-height: 20px;
      border-radius: 4px;
      padding: 10px 18px;
      margin: 10px 0 !important;
      img {
        width: 28px;
        height: 22px;
        margin-right: 14px;
      }
      .title {
        font-weight: bold;
      }
      .im-title {
        max-width: 270px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .question-left {
        display: flex;
      }
      .question-left-content {
        color: #666;
      }
      .im.question-left-content {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出2行省略 */
        overflow: hidden;
      }

      .icon-right {
        margin-left: 10px;
      }
    }
    // 查看更多
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      font-size: 13px;
      line-height: 18px;
      font-weight: bold;
      margin-top: 15px;
      cursor: pointer;
    }
  }
  .more-detail-modal {
    position: fixed;
    right: 0;
    bottom: 90px;
    width: 600px;
    height: 700px;
    z-index: 999;
  }
  .more-detail {
    height: 100%;
    background: #ffffff;

    padding: 16px 24px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.18);
    border-radius: 10px 0px 0px 10px;
    overflow-x: hidden;
    overflow-y: scroll;
    .close {
      position: absolute;
      top: -12px;
      left: -12px;
      width: 24px;
      height: 24px;
      font-size: 24px;
      color: #999999;
      cursor: pointer;
      z-index: 2002;
    }
    /deep/.el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>


<style scoped lang="less">
@import "./IM.less";
</style>


